<template>
  <div class="manuscript">
    <div class="main-form">
      <div class="main-form-title">上传您的设计稿</div>
      <div class="form-category">
        <CaseInsensitiveCascader
          :data="cascader_data"
          :value="cascader_value"
          @on-change="on_cascader_change"
          placeholder="请选择款式品类"
          filterable
          transfer
        ></CaseInsensitiveCascader>
      </div>
      <div class="main-image">
        <template v-if="main_file.raw">
          <template v-if="util.test_image(main_file.raw)">
            <img
              :src="main_file.raw"
              v-viewer
              alt=""
              style="width: 100%; height: 100%; object-fit: contain"
            />
          </template>
          <template v-else>
            <img :src="util.get_image_icon(main_file.raw)" class="icon-doc" />
            <a
              :href="main_file.raw"
              target="_blank"
              style="width: 100%; text-align: center"
              >{{ main_file.raw_name }}</a
            >
          </template>
        </template>
        <template v-else>
          <Upload
            :action="upload_url"
            :data="{ dir: 'template' }"
            :before-upload="(file) => onBeforeUpload(file, 'image_list')"
            :show-upload-list="false"
            type="drag"
            multiple
          >
            <div class="upload-btn">
              <img
                alt=""
                class="icon-upload"
                src="@/assets/images/icon-add-3.png"
                style="object-fit: cover"
              />
              <p>支持图片文件上传，jpg,png,psd,cdr等</p>
            </div>
          </Upload>
        </template>
      </div>
      <div class="image-list">
        <div
          class="image-item"
          v-for="(v, k) in form_data.image_list"
          :key="`i` + k"
          draggable
          @dragstart="handleDragStart($event, k)"
          @dragover.prevent
          @drop="handleDrop($event, k)"
          @click.prevent.stop="set_image(v)"
        >
          <template v-if="typeof v === 'string'">
            <img :src="v" alt="" style="object-fit: cover" />
          </template>
          <template v-else>
            <img
              v-if="util.test_image(v.raw)"
              :src="v.raw"
              alt=""
              style="object-fit: cover"
            />
            <img
              v-else
              :src="util.get_image_icon(v.raw)"
              alt=""
              style="object-fit: cover"
            />
          </template>
          <img
            alt=""
            class="icon-close"
            src="@/assets/images/icon-close@2x.png"
            @click.prevent.stop="del_img(k)"
          />
        </div>
        <Upload
          :action="upload_url"
          :data="{ dir: 'template' }"
          :before-upload="(file) => onBeforeUpload(file, 'image_list')"
          :show-upload-list="false"
          multiple
        >
          <div class="image-item">
            <span>+</span>
            <span>添加</span>
          </div>
        </Upload>
      </div>
      <div class="main-form-title">一版多款设置</div>
      <div class="multiple-wrap">
        <img
          v-if="form_data.is_multiple"
          src="@/assets/images/design/icon-checkbox-selected.png"
          alt=""
          class="cursor icon-check"
          @click="toggle_multi"
        />
        <img
          v-else
          src="@/assets/images/design/icon-check-no.png"
          alt=""
          class="cursor icon-check"
          @click="toggle_multi"
        />
        <span>同一个版型制作多个款式</span>
      </div>
      <div class="multiple-form" v-if="form_data.is_multiple">
        <div class="multiple-tips">请为每个款式备注名称，以便后期下单</div>
        <div class="multiple-form-body">
          <div
            class="multiple-item"
            v-for="(item, k) in form_data.children"
            :key="k"
          >
            <div class="item-label">款式{{ k + 1 }}</div>
            <Input
              placeholder="请输入款式名称"
              :value="form_data.children[k].name"
              @on-change="input2($event, 'children', k, 'name')"
            ></Input>
            <img
              src="@/assets/images/design/icon-del-2.png"
              alt=""
              class="btn-del"
              @click="del_child(k)"
            />
          </div>
          <div class="btn-add" @click="add_child">添加</div>
        </div>
      </div>
      <div class="main-form-title mt-40">款式说明</div>
      <textarea
        placeholder="请输入款式说明"
        :value="form_data.description"
        class="main-form-textarea"
        @input="input1($event, 'description')"
      ></textarea>
    </div>
    <div class="main-content">
      <div class="pattern-type-box">
        <div class="box-title">服装版型选择</div>
        <label
          :class="[
            'pattern-type-item',
            { active: form_data.pattern_type === 1 },
          ]"
        >
          <div class="item-left">
            <img
              src="@/assets/images/design/icon-platform-pattern.png"
              alt=""
              class="type-icon"
            />
            选择平台现有版型
          </div>
          <input
            type="radio"
            name="pattern_type"
            :checked="form_data.pattern_type === 1"
            :class="{ 'radio-checked': form_data.pattern_type === 1 }"
            @click.prevent="choose_pattern_type(1)"
          />
        </label>
        <label
          :class="[
            'pattern-type-item',
            { active: form_data.pattern_type === 2 },
          ]"
        >
          <div class="item-left">
            <img
              src="@/assets/images/design/icon-self-pattern.png"
              alt=""
              class="type-icon"
            />
            选择上传自己的版型文件
          </div>
          <input
            type="radio"
            name="pattern_type"
            :checked="form_data.pattern_type === 2"
            :class="{ 'radio-checked': form_data.pattern_type === 2 }"
            @click.prevent="choose_pattern_type(2)"
          />
        </label>
        <label
          :class="[
            'pattern-type-item',
            { active: form_data.pattern_type === 3 },
          ]"
        >
          <div class="item-left">
            <img
              src="@/assets/images/design/icon-custom-pattern.png"
              alt=""
              class="type-icon"
            />
            选择版型定制服务
          </div>
          <input
            type="radio"
            name="pattern_type"
            :checked="form_data.pattern_type === 3"
            :class="{ 'radio-checked': form_data.pattern_type === 3 }"
            @click.prevent="choose_pattern_type(3)"
          />
        </label>
        <div
          @click="toggleMyPatternLibrary"
          :class="['toggle-my-pattern-btn', { active: show_my_pattern_library }]"
        >
          {{ show_my_pattern_library ? '隐藏' : '显示' }}我的版型库
        </div>
      </div>
      <template v-if="form_data.pattern_type && !show_my_pattern_library">
        <div class="pattern-content-box">
          <div
            class="pattern-selected-box"
            v-if="form_data.pattern_type == 1 && form_data.pattern.length > 0"
          >
            <div class="selected-box-title">
              <div class="selected-title-info">已选择版型信息：</div>
              <div class="selected-title-tag">平台版型</div>
              <span>{{ form_data.style_no_push }}</span>
            </div>
            <div
              class="select-pattern-info"
              v-for="(item, index) in form_data.pattern"
              :key="index"
            >
              <Icon
                type="md-close"
                class="close-icon"
                @click="cancel_pattern(item)"
              />
              <img :src="item.image | default_img" alt="" class="pattern-img" />
              <div class="pattern-info-item-list">
                <div class="pattern-info-item">
                  <div class="info-item-label name-info">{{ item.name }}</div>
                  <div class="info-item-value">
                    适用性别:{{ curr_sex | sex_filter }}
                  </div>
                </div>
                <div class="pattern-info-item">
                  <div class="info-item-label">面料耗量(米):</div>
                  <div class="info-item-value">{{ form_data.consumption }}</div>
                </div>
                <div class="pattern-info-item">
                  <div class="info-item-label">里料耗量(米):</div>
                  <div class="info-item-value">
                    {{ form_data.consumption2 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content-body">
            <template v-if="form_data.pattern_type == 1">
                <div class="top">
                <div class="title-box">
                    <div class="title-item active">
                    平台版型选择
                    </div>
                </div>
                <!-- <h2>版型选择</h2> -->
                <div class="input-wrap">
                    <input
                    v-model="form_data_pattern.keyword"
                    placeholder="输入关键词进行搜索版型"
                    type="text"
                    @keyup.enter="search_pattern"
                    />
                    <img
                    alt=""
                    class="icon-search"
                    src="@/assets/images/icon-search.png"
                    @click="search_pattern"
                    />
                </div>
                </div>
                <div class="content-container">
                <template v-if="is_loading">
                    <Spin fix>
                    <Icon
                        type="ios-loading"
                        size="18"
                        class="demo-spin-icon-load"
                    ></Icon>
                    <div>Loading</div>
                    </Spin>
                </template>
                <div class="side-category-list">
                    <div
                    :class="[
                        'category-item',
                        {
                        active:
                            current_pattern_category_id === v.pattern_category_id,
                        },
                    ]"
                    v-for="(v, k) in pattern_category_list"
                    :key="`pc` + k"
                    @click="choose_pattern_category(v)"
                    >
                    {{ v.category_name }}
                    </div>
                </div>
                <div class="content-body-container">
                    <div class="top-category-list">
                    <div class="top-cate-item">
                        <div class="top-cate-label">性别:</div>
                        <div class="top-cate-list">
                        <div
                            :class="[
                            'cate-list-item',
                            { active: form_data_pattern.sex === 0 },
                            ]"
                            @click="choose_pattern_sex(0)"
                        >
                            不限
                        </div>
                        <div
                            :class="[
                            'cate-list-item',
                            { active: form_data_pattern.sex === 1 },
                            ]"
                            @click="choose_pattern_sex(1)"
                        >
                            男
                        </div>
                        <div
                            :class="[
                            'cate-list-item',
                            { active: form_data_pattern.sex === 2 },
                            ]"
                            @click="choose_pattern_sex(2)"
                        >
                            女
                        </div>
                        <div
                            :class="[
                            'cate-list-item',
                            { active: form_data_pattern.sex === 3 },
                            ]"
                            @click="choose_pattern_sex(3)"
                        >
                            儿童
                        </div>
                        </div>
                    </div>
                    <div
                        class="top-cate-item"
                        v-for="(v, k) in pattern_label_list"
                        :key="`top-cate-${k}`"
                    >
                        <div class="top-cate-label">{{ v.label_name }}:</div>
                        <div class="top-cate-list">
                        <div
                            v-for="(vv, kk) in v.content"
                            :key="`top-cate-${kk}-${kk}`"
                            :class="[
                            'cate-list-item',
                            { active: pattern_label_ids.includes(vv.id) },
                            ]"
                            @click="choose_label(vv)"
                        >
                            {{ vv.name }}
                        </div>
                        </div>
                    </div>
                    </div>
                    <div class="list-body" v-if="!is_loading">
                    <div class="empty-list" v-if="!pattern_list.length">
                      <img src="@/assets/images/bg-empty-pattern.png" alt="" class="empty-bg" />
                      <div class="empty-text">当前分类暂无版型</div>
                      <div class="empty-tips">您可切换其他分类选用，也可选择上传自己的自定义版型 或选择平台版型定制服务进行版型定制</div>
                    </div>
                    <div
                        v-for="(v, k) in pattern_list"
                        :class="[
                            'list-item',
                            { active: form_data.pattern_id === v.id },
                        ]"
                        @click="open_pattern_detail(v)"
                        :key="`df-${v.id || k}`"
                        >
                        <img
                            v-if="form_data.pattern_id === v.id"
                            alt=""
                            class="check-icon"
                            src="@/assets/images/icon-check.png"
                        />
                        <div class="cover-img-box">
                            <img :src="v.main_image | default_img" />
                            <div v-if="v.is_last_used" class="last-used-tag">最近使用</div>
                            <div class="img-hover">
                            <div v-if="v.style_label || v.is_last_used" class="label-tag">
                                {{ v.style_label }}<span v-if="v.style_label && v.is_last_used">|</span> <span v-if="v.is_last_used">最近使用</span>
                            </div>
                            <img v-if="v.model_url" src="@/assets/images/design/icon-3d-model.png" alt="" class="model-3d" @click.stop="onViewModel(v.model_url)" />
                            <div class="hover-btn-box">
                                <div
                                class="hover-btn-item"
                                @click.stop="open_pattern_detail(v)"
                                >
                                查看
                                </div>
                                <div
                                class="hover-btn-item"
                                @click.stop="cancel_pattern(v)"
                                v-if="form_data.pattern_id === v.id"
                                >
                                取消
                                </div>
                                <div
                                class="hover-btn-item"
                                @click.stop="confirm_pattern(v)"
                                v-else
                                >
                                选择
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="name-box">
                            <span>{{ v.pattern_number }}</span>
                        </div>
                    </div>
                    </div>
                    <!-- 分页 -->
                    <Page
                    :current="form_data_pattern.page"
                    v-if="total > 0"
                    :page-size="form_data_pattern.size"
                    :total="total"
                    @on-change="changePage"
                    show-total
                    ></Page>
                </div>
                </div>
            </template>
            <template v-if="form_data.pattern_type == 2">
                <div class="self-pattern-form" v-for="(item,index) in form_data.pattern" :key="index">
                    <div class="label-title">{{form_data.style_no_push}}</div>
                    <div class="label-title">上传版型文件：<span>{{ file_type.join(',') }}</span></div>
                    <Upload
                        v-if="!isPatternFormDisabled"
                        :action="upload_url"
                        :data="{ dir: 'template' }"
                        :before-upload="(file) => onBeforeUploadPattern(file, 'path', 'self')"
                        :show-upload-list="false"
                    >
                        <div class="upload-btn">
                            <img
                                class="upload-ico"
                                src="@/assets/images/design/icon-upload-black.png"
                                alt=""
                            />
                            点击上传版型文件
                        </div>
                    </Upload>
                    <div v-else class="upload-btn btn-disabled">
                        <img
                            class="upload-ico"
                            src="@/assets/images/design/icon-upload-black.png"
                            alt=""
                        />
                        点击上传版型文件
                    </div>
                    <div class="self-pattern-box">
                        <div class="self-pattern-file-box">
                            <div class="file-item" v-for="(file,fi) in item.files" :key="`fi-${fi}`">
                                <Icon type="md-close" :class="['close-btn', { 'icon-disabled': isPatternFormDisabled }]" @click="onDelSelfFile(fi)" />
                                <img :src="(file.path ? util.get_image_icon(file.path) : '')|default_img(false)" alt="" class="file-ico" />
                                <div class="file-name">{{file.name}}</div>
                            </div>
                            <div class="form-item mt-16">
                                <div class="form-item-label">使用性别：</div>
                                <div class="form-item-radio-group">
                                    <div v-for="(item,index) in ['男','女']" :key="index" :class="['radio-item', { 'radio-disabled': isPatternFormDisabled }]" @click="!isPatternFormDisabled && onSelectSex(item)">
                                        <input type="radio" name="sex" :value="item" :checked="form_data.pattern[0] && form_data.pattern[0].sex === item" :disabled="isPatternFormDisabled" />
                                        <span>{{item}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-item mt-16">
                                <div class="form-item-label">面料耗量(米)：</div>
                                <div class="form-item-input">
                                    <input type="number" 
                                    :value="form_data.consumption" 
                                    @input="input1($event, 'consumption')"
                                    :disabled="form_data.pattern_id > 0 || isPatternFormDisabled" />
                                </div>
                                <div class="form-item-label">里料耗量(米)：</div>
                                <div class="form-item-input">
                                    <input type="number" 
                                    :value="form_data.consumption2" 
                                    @input="input1($event, 'consumption2')"
                                    :disabled="form_data.pattern_id > 0 || isPatternFormDisabled" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="label-title">版型规格表：</div>
                    <div class="self-spec-file-box">
                        <div class="custom-pattern-file-box">
                            <div class="custom-pattern-file-item" v-if="!!item.guige_path">
                                <div class="doc-wrap">
                                    <img
                                        :src="
                                            (item.guige_path ? util.get_image_icon(item.guige_path) : '')
                                                | default_img(false)
                                        "
                                        class="icon-doc"
                                    />
                                    <span 
                                        @click="onOpenGuigeFile(item.guige_path)"
                                        :class="{ 'link-disabled': isPatternFormDisabled }"
                                    >{{
                                        item.guige_name
                                    }}</span>
                                </div>
                                <Icon
                                    type="md-close"
                                    :class="['del-file-icon', { 'icon-disabled': isPatternFormDisabled }]"
                                    size="18px"
                                    color="#999999"
                                    @click="onDelGuigeFile"
                                />
                            </div>
                        </div>
                         <Upload
                            :action="upload_url"
                            :data="{ dir: 'template' }"
                            :before-upload="(file) => onBeforeUploadPattern(file, 'guige', 'self')"
                            :show-upload-list="false"
                            :disabled="isPatternFormDisabled"
                        >
                            <div class="upload-btn spec-btn">
                                <img
                                    class="upload-ico"
                                    src="@/assets/images/design/icon-upload-black.png"
                                    alt=""
                                />
                                上传规格表
                            </div>
                        </Upload>
                    </div>
                </div>
            </template>
            <template v-if="form_data.pattern_type == 3">
              <div class="custom-pattern-form">
              <div class="pattern-title">定制版型服务 <span>{{form_data.style_no_push}}</span></div>
              <div class="custom-pattern-service">
                <div class="service-item">
                  <div class="service-item-label">难度:</div>
                  <div class="form-item-radio-group">
                    <div v-for="(vv, kk) in ['简单款', '复杂款']" :key="`pc-${kk}`" :class="['radio-item', { 'radio-disabled': isPatternFormDisabled }]" @click="!isPatternFormDisabled && onSelectDifficulty(vv)">
                      <input type="radio" name="difficulty" :value="vv" :checked="form_data.pattern[0] && form_data.pattern[0].difficulty === vv" :disabled="isPatternFormDisabled" />
                      <span>{{vv}}</span>
                    </div>
                  </div>
                  <p v-if="form_data.pattern[0] && form_data.pattern[0].difficulty">
                    <span>{{
                      form_data.pattern[0].difficulty == "简单款"
                        ? simple_pattern_desc
                        : difficulty_pattern_desc
                    }}</span>
                  </p>
                </div>
                <div class="service-item">
                  <div class="service-item-label">性别:</div>
                  <div class="form-item-radio-group">
                    <div v-for="(vv, kk) in ['男', '女']" :key="`pc-${kk}`" :class="['radio-item', { 'radio-disabled': isPatternFormDisabled }]" @click="!isPatternFormDisabled && onSelectSex(vv)">
                      <input type="radio" name="sex" :value="vv" :checked="form_data.pattern[0] && form_data.pattern[0].sex === vv" :disabled="isPatternFormDisabled" />
                      <span>{{vv}}</span>
                    </div>
                  </div>
                </div>
                <div class="service-item">
                  <div class="service-item-label">使用场景:</div>
                  <div class="form-item-radio-group">
                    <div v-for="(vv, kk) in custom_scene" :key="`pc-${kk}`" :class="['radio-item', { 'radio-disabled': isPatternFormDisabled }]" @click="!isPatternFormDisabled && onSelectCScene(vv)">
                      <input type="radio" name="c_scene" :value="vv" :checked="form_data.pattern[0] && form_data.pattern[0].c_scene === vv" :disabled="isPatternFormDisabled" />
                      <span>{{vv}}</span>
                    </div>
                  </div>
                </div>
                <div class="service-item">
                  <div class="service-item-label">版型类型:</div>
                  <div class="form-item-radio-group">
                    <div v-for="(vv, kk) in custom_type" :key="`pc-${kk}`" :class="['radio-item', { 'radio-disabled': isPatternFormDisabled }]" @click="!isPatternFormDisabled && onSelectCType(vv)">
                      <input type="radio" name="c_type" :value="vv" :checked="form_data.pattern[0] && form_data.pattern[0].c_type === vv" :disabled="isPatternFormDisabled" />
                      <span>{{vv}}</span>
                    </div>
                  </div>
                </div>
                <div class="service-item">
                  <div class="service-item-label">版型说明:</div>
                  <textarea
                    placeholder="请输入版型说明"
                    @input="fill_custom_pattern2($event)"
                    :value="form_data.pattern[0] ? form_data.pattern[0].c_content : ''"
                    :disabled="isPatternFormDisabled"
                  ></textarea>
                </div>
                  <div class="custom-service-file-box">
                    <div class="custom-service-file-item" v-if="!!form_data.pattern[0] && !!form_data.pattern[0].path">
                      <div class="doc-wrap" :title="form_data.pattern[0].name">
                        <img
                          :src="
                            (form_data.pattern[0].path ? util.get_image_icon(form_data.pattern[0].path) : '')
                              | default_img(false)
                          "
                          class="icon-doc"
                        />
                        <span 
                          @click="onOpenGuigeFile(form_data.pattern[0].path)"
                          :class="{ 'link-disabled': isPatternFormDisabled }"
                        >{{ form_data.pattern[0].name }}</span>
                      </div>
                      <Icon
                        type="md-close"
                        :class="['del-file-icon', { 'icon-disabled': isPatternFormDisabled }]"
                        size="18px"
                        color="#999999"
                        @click="onDelCustomPath"
                      />
                    </div>
                    <Upload
                    :action="upload_url"
                    :data="{ dir: 'template' }"
                    :before-upload="
                      (file) => isPatternFormDisabled ? false : onBeforeUploadPattern(file, 'path', 'custom')
                    "
                    :show-upload-list="false" :disabled="isPatternFormDisabled"
                  >
                    <div
                      :class="['btn-upload cursor', { 'btn-disabled': isPatternFormDisabled }]"
                    >
                      <img
                        class="icon"
                        src="@/assets/images/design/icon-upload-black.png"
                        alt=""
                      />
                      <span>上传版型文件</span>
                    </div>
                  </Upload>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
      <div class="my-pattern-library-box" v-if="show_my_pattern_library">
        <div class="library-wrapper">
          <div class="library-header">
          <div class="library-title">我的版型库</div>
          <!-- 搜索和筛选区域 -->
          <div class="pattern-search-filter-box">
            <div class="search-input-wrap">
              <input
                v-model="pattern_search_keyword"
                placeholder="输入关键词搜索版型"
                type="text"
                @keyup.enter="onSearchPatternLibrary"
              />
              <img
                alt=""
                class="icon-search"
                src="@/assets/images/icon-search.png"
                @click="onSearchPatternLibrary"
              />
            </div>
            <div class="filter-select-wrap" v-if="current_pattern_menu == 1">
              <select v-model="pattern_category_filter" @change="onFilterPatternCategory">
                <option value="">全部分类</option>
                <option v-for="(item,index) in history_pattern_cate_list" :key="index" :value="item.product_category_id">{{item.category_name_cn}}</option>
              </select>
            </div>
          </div>
          <div class="library-close" @click="show_my_pattern_library = false">×</div>
        </div>
        <div class="library-body">
          <template v-if="is_loading">
            <Spin fix>
              <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
          </template>
          <div class="my-pattern-menu">
            <div
              :class="['menu-parent-item', { active: current_pattern_menu == 1 }]"
              @click="onMenuChange(1)"
            >
              <img
                :src="current_pattern_menu == 1 ? require('@/assets/images/team/icon-team-history-active.png') : require('@/assets/images/team/icon-team-history.png')"
                alt=""
                class="menu-icon"
              />我的历史版型
            </div>
            <div v-if="team_list.length>0"
              :class="['menu-parent-item', { active: current_pattern_menu == 2 }]"
              @click="onMenuChange(2)"
            >
              <img
                :src="current_pattern_menu == 2 ? require('@/assets/images/team/icon-team-folder-tree-active.png') : require('@/assets/images/team/icon-team-folder-tree.png')"
                alt=""
                class="menu-icon"
              />
              <div class="label-name">
                团队资源库
                <Icon :type="current_pattern_menu == 2 ? 'ios-arrow-down' : 'ios-arrow-forward'" size="16" />
              </div>
            </div>
            <ul v-if="current_pattern_menu == 2">
              <li
                v-for="(item, index) in team_list"
                :class="[{ 'active-team': curr_team.id == item.id }]"
                :key="index"
                @click="onTeamChoose(item)"
              >
                <span>{{ item.name }}</span>
              </li>
            </ul>
          </div>
          <div class="library-content">
            <div v-if="current_pattern_menu == 1" :class="[{ 'history-tag-box': false }]">
              <div class="history-tab" v-if="false">
                <div :class="['tag-item', { active: current_history_type == -1 }]" @click="current_history_type = -1">全部版型</div>
                <div :class="['tag-item', { active: current_history_type == 2 }]" @click="current_history_type = 2">上传的版型</div>
                <div :class="['tag-item', { active: current_history_type == 1 }]" @click="current_history_type = 1">平台的版型</div>
                <div :class="['tag-item', { active: current_history_type == 3 }]" @click="current_history_type = 3">定制的版型</div>
              </div>
              <div class="batch-box" v-if="false">
                <template v-if="batch_mode">
                  <Checkbox>全选</Checkbox>
                  <div class="batch-btn">加入团队资源库</div>
                </template>
                <div class="batch-btn" @click="batch_mode = !batch_mode">{{ batch_mode ? "退出管理" : "批量管理" }}</div>
              </div>
            </div>
            <div class="history-tag-box" v-else>
              <div
                :class="['tag-item-folder', { 'folder-item-active': !curr_second_folder.uuid }]"
                @click="folder_list[0] && onGetTeamFolderFileList(folder_list[0], true, true)"
              >
                全部版型({{ folder_list[0] && folder_list[0].count ? folder_list[0].count : 0 }})
              </div>
              <div
                v-for="(item, index) in secondaryList"
                :key="index"
                :class="['tag-item-folder', { 'folder-item-active': curr_second_folder.uuid == item.uuid }]"
                @click="onGetTeamFolderFileList(item, true, false)"
              >
                {{ item.name }}({{ item && item.count ? item.count : 0 }})
              </div>
              <Icon
                :type="show_more_folder ? 'ios-arrow-up' : 'ios-arrow-down'"
                class="cursor"
                size="16"
                @click="show_more_folder = !show_more_folder"
              />
            </div>
            <div class="list-body">
              <table>
                <thead>
                  <tr>
                    <th v-if="current_pattern_menu == 1 && batch_mode" style="width: 16px; height: 16px; text-align: center;"></th>
                    <template v-if="current_pattern_menu == 1">
                      <th style="text-align: center">版型号</th>
                      <th style="text-align: center">性别</th>
                      <th style="text-align: center">历史款号</th>
                    </template>
                    <template v-else>
                      <th style="width: 40%; text-align: center">版型信息</th>
                      <th style="text-align: center">版型类型</th>
                    </template>
                    <th style="text-align: center">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="current_pattern_menu == 1">
                    <tr
                      v-for="(item, index) in history_pattern_list"
                      :key="index"
                      :class="['tr-relative', { 'tr-active': form_data.pattern[0] && item.id === form_data.pattern[0].id }]"
                      @click="onHistoryPatternView(item)"
                    >
                      <td v-if="current_pattern_menu == 1 && batch_mode" style="width: 16px; height: 16px"><Checkbox></Checkbox></td>
                      <td><div class="pattern-no">{{ item.library_key || item.pattern_number || "-" }}</div></td>
                      <td><div class="sex-info"><template v-if="item.sex != null && item.sex !== ''">{{ item.sex | sex_filter }}</template><template v-else-if="item.pattern && item.pattern.sex != null && item.pattern.sex !== ''">{{ isNaN(item.pattern.sex) ? item.pattern.sex : (item.pattern.sex | sex_filter) }}</template><template v-else>-</template></div></td>
                      <td><div class="style-col">{{ item.style_no || "-" }}</div></td>
                      <td>
                        <div class="operation-col">
                          <div class="left-operation">
                            <div class="btn" @click.stop="onHistoryPatternView(item)">查看</div>
                            <div class="line">|</div>
                            <div class="btn" @click.stop="onChooseHistoryPattern(item, form_data.pattern[0] && form_data.pattern[0].id === item.id)">
                              {{ form_data.pattern[0] && form_data.pattern[0].id === item.id ? "取消" : "选择" }}
                            </div>
                          </div>
                          <div v-if="current_pattern_menu == 1" class="add-to-team" @click.stop="onAddTeamFile(item)">加入团队资源库</div>
                        </div>
                        <img v-if="form_data.pattern[0] && item.id === form_data.pattern[0].id" src="@/assets/images/icon-check.png" alt="" class="selected-icon" />
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr
                      v-for="(item, index) in team_pattern_list"
                      :key="index"
                      :class="['tr-relative', { 'tr-active': form_data.pattern[0] && item.id === form_data.pattern[0].id }]"
                      @click="onTeamFileView(item)"
                    >
                      <td>
                        <div class="info-container">
                          <img
                            :src="(item.info && item.info.image && util.test_image(item.info.image) ? item.info.image : item.info && item.info.path ? item.info.path ? util.get_image_icon(item.info.path) : '' : '') | default_img(false)"
                            alt=""
                            class="cover-img"
                          />
                          <div class="item-info">
                            <div class="title">
                              <div class="main" :title="item.name">{{ item.name }}</div>
                              <div :class="['sub', item.info.pattern_type == 1 ? 'own-pattern' : 'custom-pattern']">[{{ item.info.pattern_type | pattern_type_filter }}]</div>
                            </div>
                            <div class="info">
                              <div>适用性别:<template v-if="isNaN(item.info.sex)">{{ item.info.sex || "-" }}</template><template v-else>{{ item.info.sex | sex_filter }}</template></div>
                              <div class="style-no team">
                                <div>面料耗量:{{ item.info.consumption || "-" }}</div>
                                <div>里料耗量:{{ item.info.consumption2 || "-" }}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td><div class="style-col">{{ item.info.pattern_type | pattern_type_filter }}</div></td>
                      <td>
                        <div class="operation-col">
                          <div class="left-operation">
                            <template v-if="item.info.pattern_type == 1">
                              <div class="btn" @click.stop="onTeamFileView(item)">查看</div>
                              <div class="line">|</div>
                            </template>
                            <div class="btn" @click.stop="onTeamFileChoose({ ...item.pattern, ...item.info, file_key: item.file_key }, form_data.pattern[0] && form_data.pattern[0].id === item.id)">
                              {{ form_data.pattern[0] && form_data.pattern[0].id === item.id ? "取消" : "选择" }}
                            </div>
                          </div>
                          <div v-if="current_pattern_menu == 1" class="add-to-team" @click.stop="onAddTeamFile(item)">加入团队资源库</div>
                        </div>
                        <img v-if="form_data.pattern[0] && item.id === form_data.pattern[0].id" src="@/assets/images/icon-check.png" alt="" class="selected-icon" />
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <Page
              :current="form_data_pattern.page"
              :page-size="form_data_pattern.size"
              :total="total"
              @on-change="changePage"
              show-total
            ></Page>
          </div>
        </div>
        </div>
      </div>
      <div class="lesson-box" v-if="!form_data.pattern_type && !show_my_pattern_library">
        <lesson></lesson>
      </div>
    </div>
    <popup :show.sync="is_popup_show_detail" height="680px" width="980px">
      <div class="fabric-content-wrap" ref="detailPopupContent">
        <div class="info-wrap">
          <div class="left-popup">
            <div
              v-if="
                current_pattern.image_list &&
                current_pattern.image_list.length > 0
              "
              class="slider"
            >
              <swiper ref="swiper" :options="swiperOption">
                <swiper-slide
                  v-for="(item, index) in current_pattern.image_list"
                  :key="`sl` + index"
                >
                  <img v-viewer :src="item.url" class="f-img" />
                </swiper-slide>
                <div slot="button-prev" class="swiper-button-prev"></div>
                <div slot="button-next" class="swiper-button-next"></div>
              </swiper>
            </div>
          </div>
          <div class="right">
            <div class="name">
              {{ current_pattern.pattern_number }}
              <div v-if="current_pattern.model_url" class="model-btn" @click.stop="onViewModel(current_pattern.model_url)">
                <img src="@/assets/images/design/icon-3d-circle.png" alt="" class="model-btn-icon"> 查看3D
              </div>
            </div>
            <!-- category_name -->
            <p class="no">
              风格:<span>{{ current_pattern.style_label }}</span>
            </p>
            <p class="no">
              类别:<span>{{ current_pattern.category_name }}</span>
            </p>
            <p class="no">
              性别:<span>{{ current_pattern.sex | sex_filter }}</span>
            </p>
            <p class="no">
              面料耗量(米):<span>{{ current_pattern.consumption }}</span>
            </p>
            <p class="no" v-show="current_pattern.consumption2 > 0">
              里料耗量(米):<span>{{ current_pattern.consumption2 }}</span>
            </p>
          </div>
        </div>
        <div class="title-box">
          <div class="title">规格尺寸详情说明</div>
          <div class="line"></div>
        </div>

        <div class="richtext-wrap">
          <div v-html="current_pattern.description"></div>
          <div class="size-list">
            尺码:<span
              v-for="(item, index) in current_pattern.size_list"
              :key="index"
              >{{ item }}</span
            >
          </div>
          <table border="none">
            <thead>
              <tr style="background: #e5e5e5; text-align: center">
                <th style="background: transparent !important">尺码/部位</th>
                <th v-for="part in current_pattern.part_list" :key="part">
                  {{ getPatternName(part) }}
                </th>
              </tr>
            </thead>
            <tbody border="none">
              <tr
                v-for="row in table_data"
                :key="row.size"
                style="text-align: center"
              >
                <td style="width: auto; min-width: 100px; max-width: 150px">
                  {{ row.size }}
                </td>
                <td
                  border="none"
                  v-for="part in current_pattern.part_list"
                  :key="`${row.size}-${part}`"
                  style="width: 100px"
                >
                  <div>
                    {{ row[part] && row[part].normal ? row[part].normal : "-" }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="btn-box">
        <button class="cancel-btn" @click="is_popup_show_detail = false">
          取消
        </button>
        <button class="confirm-btn" @click="toggle_pattern(current_pattern)">
          确认
        </button>
      </div>
    </popup>

    <popup :show.sync="show_custom_pattern_detail" height="680px" width="980px">
      <div class="custom-fabric-detail">
        <div class="title">版型详情</div>
        <div class="detail-body" v-if="current_pattern.pattern">
          <div class="container">
            <div class="main-file">
              <div class="file-container">
                <div class="file-left">
                  <img
                    :src="
                      (current_pattern && current_pattern.pattern.path
                        ? util.get_image_icon(current_pattern.pattern.path)
                        : '') | default_img(false)
                    "
                    alt=""
                    class="file-ico"
                  />
                  <div class="file-name-box">
                    <div class="name">{{ current_pattern.pattern.name }}</div>
                    <div class="type">{{ (current_pattern.pattern_type || (current_pattern.info && current_pattern.info.pattern_type) || '2') | pattern_type_filter }}</div>
                  </div>
                </div>
                <div
                  class="down-btn"
                  v-if="current_pattern.pattern.path"
                  @click="onDownloadFile(current_pattern.pattern.path)"
                ></div>
              </div>
            </div>
            <div class="main-info">
              <div class="info-item">
                <div class="info-label">使用款号:</div>
                <div class="info-value">{{ current_pattern.style_no }}</div>
              </div>
              <div class="info-item">
                <div class="info-label">适用性别:</div>
                <div class="info-value">
                  <template v-if="current_pattern.sex">{{ current_pattern.sex | sex_filter }}</template>
                  <template v-else>{{ current_pattern.pattern.sex || '-' }}</template>
                </div>
              </div>
              <div class="info-item">
                <div class="info-label">面料耗量(M):</div>
                <div class="info-value">
                  {{ current_pattern.consumption || "0" }}
                </div>
              </div>
              <div class="info-item">
                <div class="info-label">里料耗量(M):</div>
                <div class="info-value">
                  {{ current_pattern.consumption2 || "0" }}
                </div>
              </div>
            </div>
            <div class="part-title">
              <div class="title-name">规格表</div>
              <div class="title-line"></div>
            </div>
            <div
              class="file-list-box"
              v-if="
                current_pattern.pattern &&
                current_pattern.pattern.guige_name &&
                current_pattern.pattern.guige_path
              "
            >
              <div
                class="file-list-item"
                v-for="(item, index) in [current_pattern.pattern]"
                :key="index"
              >
                <div class="list-item-container">
                  <div class="list-item-left">
                    <img
                      :src="
                        (item.guige_path
                          ? util.get_image_icon(item.guige_path)
                          : '') | default_img(false)
                      "
                      alt=""
                      class="item-file-icon"
                    />
                    <div class="item-file-name">{{ item.guige_name }}</div>
                  </div>
                  <div
                    class="list-item-right"
                    v-if="item.guige_path"
                    @click="onDownloadFile(item.guige_path)"
                  >
                    下载
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-bottom">
          <div class="cancel-btn" @click="onCancelCustomDetail">取消</div>
          <div
            class="confirm-btn"
            @click="onChooseHistoryPattern(current_pattern)"
          >
            确认选择
          </div>
        </div>
      </div>
    </popup>

    <!-- 团队文件夹弹窗 -->
    <move-file
      ref="moveFilePop"
      v-if="show_move_file"
      :file="curr_file"
      :teamId="ownTeam.uuid"
      :teamName="ownTeam.name"
      :rootFolderType="1"
      @on-move-success="onGetTeamFolderFileList"
      @on-close="show_move_file = false"
    />
  </div>
</template>
<script>
import {
  PatternCategoryList, // 版型分类列表接口
  PatternLabelList, // 版型标签列表接口
  PatternList, // 版型列表接口
  PatternSetting, // 版型设置接口
  folderFileCount, // 文件夹文件数量接口
  getPatternHistory, // 团队列表接口
  getPatternHistoryCate, // 获取历史版型接口
  teamFileListForDesgin, // 团队文件列表（设计用）接口
  teamFolderFileList, // 团队文件夹文件列表接口
  teamList, // 团队列表接口
} from "@/api/index.js";
import util from "@/utils/util";
import { mapState } from "vuex";
import Lesson from "./Lesson.vue";

// 导入组件
import CaseInsensitiveCascader from "@/components/CaseInsensitiveCascader/index.vue"; // 不区分大小写级联组件
import Popup from "@/components/Popup.vue"; // 弹窗组件
import MoveFile from "./MoveFile.vue"; // 移动文件组件

// 导入工具
import { uploadFileToOSS } from "@/utils/oss"; // OSS 文件上传工具

// 导入其他依赖
import axios from "axios"; // HTTP 请求库
import "swiper/dist/css/swiper.css"; // Swiper 轮播样式
import { swiper, swiperSlide } from "vue-awesome-swiper"; // Vue Swiper 组件
export default {
  name: "Manuscript",
  data() {
    return {
      util: util,
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      sub_product_category_list: [],
      is_popup_show: false,
      main_file: {
        raw: "",
        raw_name: "",
      },
      curr_package_detail: [],
      curr_sex: "",
      swiperOption: {
        loop: false, // 不循环播放
        autoplay: {
          delay: 2000, // 自动播放间隔 2 秒
          disableOnInteraction: false, // 用户操作后不停止自动播放
        },
        navigation: {
          nextEl: ".swiper-button-next", // 下一张按钮
          prevEl: ".swiper-button-prev", // 上一张按钮
        },
        pagination: {
          el: ".swiper-pagination", // 分页器元素
          clickable: true, // 可点击
        },
        observer: true, // 监听 Swiper 自身变化
        observeParents: true, // 监听 Swiper 父元素变化
      },

      // 工具函数引用
      util: util,

      // 图片上传地址
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",

      // 子产品分类列表
      sub_product_category_list: [],

      // 版型详情弹窗显示状态
      is_popup_show_detail: false,

      // 版型筛选表单数据
      form_data_pattern: {
        page: 1, // 当前页码
        size: 15, // 每页条数
        keyword: "", // 搜索关键词
        sex: 0, // 性别筛选（0=不限，1=男，2=女，3=儿童）
        pattern_category_id: 0, // 版型分类ID
      },

      // 版型分类列表
      pattern_category_list: [],

      // 平台版型列表
      pattern_list: [],

      // 版型列表请求ID（用于防止请求竞态）
      pattern_list_request_id: 0,

      // 数据总数
      total: 0,

      // 版型标签列表
      pattern_label_list: [],

      // 已选标签ID数组
      pattern_label_ids: [],

      // 当前选中的版型分类ID
      current_pattern_category_id: 0,

      // 当前选中的版型详情
      current_pattern: {
        image_list: [], // 图片列表
        field_list: [], // 字段列表
      },
      // 弹窗宽度
      width: "600px",

      // 定制场景选项
      custom_scene: [],

      // 定制类型选项
      custom_type: [],

      // 版型尺寸表格数据
      table_data: [],

      // 当前版型类型（1=平台版型，2=我的版型库）
      current_pattern_type: 1,

      // 是否显示我的版型库
      show_my_pattern_library: false,
      // 版型库搜索关键词
      pattern_search_keyword: "",
      // 版型库类别筛选
      pattern_category_filter: "",

      // 当前历史版型筛选类型（-1=全部，1=平台，2=上传，3=定制）
      current_history_type: -1,

      // 当前我的版型库菜单（1=历史版型，2=团队版型）
      current_pattern_menu: 1,

      // 定制版型详情弹窗显示状态
      show_custom_pattern_detail: false,

      // 历史版型列表
      history_pattern_list: [],

      // 团队列表
      team_list: [],

      // 当前选中的团队
      curr_team: {},

      // 文件夹列表
      folder_list: [],

      // 移动文件弹窗显示状态
      show_move_file: false,

      // 当前操作的文件
      curr_file: {},

      // 二级文件夹列表
      secondary_folder_list: [],

      // 当前选中的二级文件夹
      curr_second_folder: {},

      // 团队文件列表
      team_file_list: [],

      // 是否显示更多文件夹
      show_more_folder: false,

      // 团队版型列表
      team_pattern_list: [],

      // 批量管理模式
      batch_mode: false,

      // 复杂款版型描述
      difficulty_pattern_desc: "",

      // 简单款版型描述
      simple_pattern_desc: "",

      // 加载状态
      is_loading: false,

      // 是否为复制模式
      is_copy: false,

      // 版型来源（platform=平台，history=历史，team=团队，custom=定制）
      pattern_source: "",

      // 历史版型分类列表
      history_pattern_cate_list: [],

      file_type:[
        'pjh','plt','boke','prj','ets','dgs','pds','fgs','gmt','bpd','gph',
        'tmp','zip','mdl','pa1','pa2','pa3','pat','sty','sg','jit','ftd',
        'sak','skc','aud','pdt','pan','pax','dxf','aama','inv'
      ]
    };
  },
  components: {
    Lesson,
    Popup,
    swiper,
    swiperSlide,
    MoveFile,
    CaseInsensitiveCascader,
  },
  filters: {
    pattern_type_filter(val) {
      switch (Number(val)) {
        case 1:
          return "平台版型";
        case 2:
          return "客供版型";
        case 3:
          return "定制版型";
        default:
          return "客供版型";
      }
    },
  },
  watch: {
    "form_data.parent_product_category_id": {
      handler(newVal, oldVal) {
        console.log("base", newVal, oldVal);
        if (newVal > 0) {
          let obj = this.product_category_list.find(
            (v) => v.product_category_id === newVal,
          );
          this.sub_product_category_list = obj ? obj.children : [];
          if (oldVal > 0) {
            this.$store.commit("design/update_common", {
              key: "child_product_category_id",
              value: 0,
            });
          }
          // 查找对应的分类对象
          let obj1 = this.product_category_list.find(
            (v) => v.product_category_id === newVal,
          );
          // 更新子分类列表
          this.sub_product_category_list = obj1 ? obj1.children : [];
          // 更新版型描述
          this.difficulty_pattern_desc = obj1
            ? obj1.difficulty_pattern_desc
            : "";
          this.simple_pattern_desc = obj1 ? obj1.simple_pattern_desc : "";
          // 重置页码并重新获取版型列表
          this.form_data_pattern.page = 1;
          this.getPatternList();
        }
      },
      immediate: true, // 立即执行一次handler以初始化数据
    },
    "form_data.image": {
      handler(newVal, oldVal) {
        if (newVal) {
          this.main_file = {
            raw: newVal,
            raw_name: "",
          };
        } else if (
          this.form_data.image_list &&
          this.form_data.image_list.length > 0
        ) {
          const firstImage = this.form_data.image_list[0];
          if (typeof firstImage === "object") {
            this.main_file = firstImage;
          } else {
            this.main_file = {
              raw: firstImage,
              raw_name: "",
            };
          }
        }
      },
      immediate: true, // 组件初始化时立即执行
    },
    "form_data.child_product_category_id": {
      handler(newVal, oldVal) {
        if (newVal > 0 && newVal !== oldVal) {
          // 查找一级分类对象
          let obj = this.product_category_list.find(
            (v) =>
              v.product_category_id ===
              this.form_data.parent_product_category_id,
          );
          let children = obj && obj.children ? obj.children : null;
          if (children) {
            // 查找二级分类对象
            let child = this.sub_product_category_list.find(
              (v) => v.product_category_id === newVal,
            );
            // 更新版型描述（优先使用二级分类，其次一级分类）
            this.difficulty_pattern_desc =
              child && child.difficulty_pattern_desc
                ? child.difficulty_pattern_desc
                : obj.difficulty_pattern_desc || "";
            this.simple_pattern_desc =
              child && child.simple_pattern_desc
                ? child.simple_pattern_desc
                : obj.simple_pattern_desc || "";
          }
          // 重置页码
          this.form_data_pattern.page = 1;
          // 重新获取版型列表（仅在真正变化时调用）
          this.getPatternList();
        }
      },
      immediate: true,
      deep: true,
    },

    // 监听版型类型切换（平台版型/我的版型库）
    current_pattern_type(news, olds) {
      if (news != olds) {
        // 切换时重置页码
        this.form_data_pattern.page = 1;
        if (news == 1) {
          // 切换到平台版型
          this.getPatternList();
        } else {
          // 切换到我的版型库
          this.onGetHistoryPattern();
        }
      }
    },

    // 监听历史版型筛选类型变化
    current_history_type(news, olds) {
      if (news != olds) {
        // 重新获取历史版型列表
        this.onGetHistoryPattern();
      }
    },
  },
  computed: {
    // ...mapState({
    //   form_data: (state) => state.design.form_data,
    //   is_lesson_show: (state) => state.design.is_lesson_show,
    //   product_category_list: (state) => state.design.product_category_list,
    // }),
    // 映射 Vuex 状态
    ...mapState({
      form_data: (state) => state.design.form_data, // 表单数据
      height: (state) => state.design.height, // 高度
      is_lesson_show: (state) => state.design.is_lesson_show, // 教程显示状态
      product_category_list: (state) => state.design.product_category_list, // 产品分类列表
      setting: (state) => state.setting, // 设置
    }),

    // Cascader 数据转换
    cascader_data() {
      return this.product_category_list.map((item) => {
        const cascader_item = {
          value: item.product_category_id,
          label: item.category_name_cn,
        };
        if (item.children && item.children.length > 0) {
          cascader_item.children = item.children.map((child) => ({
            value: child.product_category_id,
            label: child.category_name_cn,
          }));
        }
        return cascader_item;
      });
    },

    // Cascader 当前值
    cascader_value() {
      const parent_id = this.form_data.parent_product_category_id;
      const child_id = this.form_data.child_product_category_id;
      if (parent_id > 0) {
        if (child_id > 0) {
          return [parent_id, child_id];
        }
        return [parent_id];
      }
      return [];
    },

    // 计算制作价格
    making_price() {
      const { parent_product_category_id, child_product_category_id, pattern } =
        this.form_data;
      // 判断是否为复杂款
      const is_complex =
        pattern && pattern[0] && pattern[0].difficulty === "复杂款";
      let base_price = 0;

      // 根据分类计算基础价格
      if (parent_product_category_id > 0) {
        const parent = this.product_category_list.find(
          (v) => v.product_category_id === parent_product_category_id,
        );

        if (
          child_product_category_id > 0 &&
          this.sub_product_category_list.length > 0
        ) {
          const child = this.sub_product_category_list.find(
            (v) => v.product_category_id === child_product_category_id,
          );
          // 优先使用子分类价格，其次父分类价格
          const child_price = child
            ? is_complex
              ? child.making_price_complex
              : child.making_price
            : 0;
          const parent_price = parent
            ? is_complex
              ? parent.making_price_complex
              : parent.making_price
            : 0;
          base_price = child_price > 0 ? child_price : parent_price;
        } else {
          base_price = parent
            ? is_complex
              ? parent.making_price_complex
              : parent.making_price
            : 0;
        }
      }

      // 计算最终价格（包含税费和利润）
      const tax_ratio =
        Number(
          this.setting && this.setting.tax_ratio ? this.setting.tax_ratio : 0,
        ) || 0;
      const sample_profit_ratio =
        Number(
          this.setting && this.setting.sample_profit_ratio
            ? this.setting.sample_profit_ratio
            : 0,
        ) || 0;
      const final_price =
        base_price * (1 + tax_ratio / 100) * (1 + sample_profit_ratio / 100);

      // 向上取整
      return Math.ceil(final_price);
    },

    // 版型表单是否禁用（从历史或团队选择版型时禁用）
    isPatternFormDisabled() {
      return Boolean(
        this.is_copy ||
          this.pattern_source === "history" ||
          this.pattern_source === "team" ||
          this.form_data.style_no_push,
      );
    },

    // 是否拥有自己的团队（角色为"所有者"）
    hasOwnTeam() {
      const { team_list } = this;
      return team_list.filter((item) => item.role === "所有者").length > 0;
    },

    // 文件夹列表（仅包含文件夹，不包含文件）
    folderList() {
      return this.folder_list.filter((item) => item.is_dir);
    },

    // 文件列表（仅包含文件，不包含文件夹）
    fileList() {
      return this.folder_list.filter((item) => !item.is_dir);
    },

    // 自己的团队（角色为"所有者"的团队）
    ownTeam() {
      const { team_list } = this;
      return team_list.find((item) => item.role === "所有者");
    },

    // 二级文件夹列表（根据是否显示更多来截取）
    secondaryList() {
      if (this.show_more_folder) {
        return this.secondary_folder_list;
      } else {
        return this.secondary_folder_list.slice(0, 5); // 只显示前5个
      }
    },
  },
  mounted() {
    //防止在点开弹窗以后直接刷新页面导致再次进入弹窗不关闭的问题
    this.$store.commit("design/hide_lesson_popup");

    // 计算弹窗宽度
    this.width = window.innerWidth - 220 - 490 - 30 + "px";

    // 判断是否为复制模式
    this.is_copy =
      this.$route.query.is_copy === "1" || this.$route.query.is_copy === 1;

    // 获取版型设置
    PatternSetting().then((response) => {
      this.custom_scene = response.data.c_scene;
      this.custom_type = response.data.c_type;
    });

    // 并行获取初始化数据
    axios
      .all([
        this.getPatternCategoryList(),
        this.getPatternLabelList(),
        this.onGetTeamList(),
        // this.onGetHistoryPattern()  // 已注释
      ])
      .then(
        axios.spread(() => {
          // return this.onGetHistoryPattern()  // 已注释
          return this.getPatternList();
        }),
      )
      .then(async () => {
        // 先检查 localStorage 中是否有选中的版型
        const selectedPatternStr = localStorage.getItem("selected_pattern");
        if (selectedPatternStr) {
          const selectedPattern = JSON.parse(selectedPatternStr);
          console.log("从 localStorage 读取到版型:", selectedPattern);

          // 清除 localStorage
          localStorage.removeItem("selected_pattern");

          // 处理版型数据
          this.processSelectedPattern(selectedPattern);
          this.$root.$emit('file-data-loaded');
        } else {
          // 处理路由参数中的文件
          const { file } = this.$route.params;
          console.log("file-mounted", file);
          if (file && file.type == "51") {
            this.current_pattern_type = 2;
            const curr_file = file;
            await this.onMenuChange(2);
            await this.onTeamFileChoose(curr_file);
            // 消费路由 file 参数：replace 必须让 fullPath 变化才能真正清除 params
            // （否则 vue-router 判定重复导航 abort，params.file 残留 → 切 tab 组件重建反复处理）
            this.$router.replace({ name: "WorkBenchDesign", query: { ...this.$route.query, file_consumed: "1" } });
          }
          this.$root.$emit('file-data-loaded');
        }
      });
  },
  methods: {
    onViewModel(url){
      if(!url) return;
      window.open(url,'_blank');
    },
    // 获取历史版型分类
    async getHistoryPatternCateList(){
      try{
        const {code,msg,data} = await getPatternHistoryCate();
        if(code>0){
          this.$layer.msg(msg);
          return;
        }
        console.log('data--patttern-history-cate-list',data);
        this.history_pattern_cate_list = data;
      }catch(err){
        console.log('err-get-history-cate',err);
      }
    },
    // 切换我的版型库显示/隐藏
    toggleMyPatternLibrary() {
      this.show_my_pattern_library = !this.show_my_pattern_library;
      if (this.show_my_pattern_library) {
        this.current_pattern_type = 2;
        this.getHistoryPatternCateList();
        this.onGetHistoryPattern();
      }
    },

    // 搜索版型库
    onSearchPatternLibrary() {
      this.form_data_pattern.page = 1;
      if (this.current_pattern_menu == 2) {
        this.onGetTeamFileForDesign();
      } else {
        this.onGetHistoryPattern();
      }
    },

    // 筛选版型类别
    onFilterPatternCategory() {
      this.form_data_pattern.page = 1;
      this.onGetHistoryPattern();
    },

    // 选择性别（带禁用检查）
    onSelectSex(val) {
      if (this.isPatternFormDisabled) return;
      this.fill_custom_pattern("sex", val);
    },

    // 删除自定义文件（带禁用检查）
    onDelSelfFile(index) {
      if (this.isPatternFormDisabled) return;
      this.del_self_file(index);
    },

    // 删除规格文件（带禁用检查）
    onDelGuigeFile() {
      if (this.isPatternFormDisabled) return;
      this.del_guige_file();
    },

    // 打开规格文件窗口（带禁用检查）
    onOpenGuigeFile(path) {
      if (this.isPatternFormDisabled) return;
      this.open_window(path);
    },

    // 选择难度（带禁用检查）
    onSelectDifficulty(val) {
      if (this.isPatternFormDisabled) return;
      this.fill_custom_pattern("difficulty", val);
    },

    // 选择定制场景（带禁用检查）
    onSelectCScene(val) {
      if (this.isPatternFormDisabled) return;
      this.fill_custom_pattern("c_scene", val);
    },

    // 选择定制类型（带禁用检查）
    onSelectCType(val) {
      if (this.isPatternFormDisabled) return;
      this.fill_custom_pattern("c_type", val);
    },

    // 删除定制路径（带禁用检查）
    onDelCustomPath() {
      if (this.isPatternFormDisabled) return;
      this.del_path();
    },

    // ---- 文件操作 ----

    // 删除文件路径
    del_path() {
      let object = this.form_data.pattern[0];
      object.name = "";
      object.path = "";
      // 清空并重新设置 pattern
      this.$store.commit("design/update_common", { key: "pattern", value: [] });
      this.$store.commit("design/arr_push_one", {
        key: "pattern",
        value: object,
      });
    },

    // 获取文件数量
    async onGetFileCount() {
      try {
        const { curr_team, folderList, folder_list, secondary_folder_list } =
          this;

        // 参数校验
        if (
          !curr_team ||
          !curr_team.uuid ||
          !folderList ||
          !folderList[0] ||
          !folderList[0].uuid
        ) {
          console.log("缺少必要的参数，无法获取文件数量");
          return;
        }

        // 构建请求参数
        const param = {};
        param.team_uuid = curr_team.uuid;
        param.folder_uuid = folderList[0].uuid;

        // 请求文件数量
        const { code, msg, data } = await folderFileCount(param);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }

        // 处理返回数据，构建数量映射
        const countMap = {};
        if (Array.isArray(data)) {
          data.forEach((item) => {
            const [id, count] = Object.entries(item)[0];
            countMap[Number(id)] = count;
          });

          // 更新一级文件夹数量
          if (folder_list[0]) {
            folder_list[0].count = countMap[folder_list[0].id] || 0;
          }

          // 更新二级文件夹数量
          if (Array.isArray(secondary_folder_list)) {
            this.secondary_folder_list = secondary_folder_list.map((item) => {
              const count = countMap[item.id] || 0;
              return {
                ...item,
                count: count,
              };
            });
          }
        }
      } catch (e) {
        console.log("err-get-file-count", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },

    // 获取团队文件列表（用于设计）
    async onGetTeamFileForDesign(is_all = false) {
      try {
        this.is_loading = true;
        const { curr_second_folder, curr_team, folderList, form_data_pattern } =
          this;

        // 参数校验
        if (
          !curr_team ||
          !curr_team.uuid ||
          !folderList ||
          !folderList[0] ||
          !folderList[0].uuid
        ) {
          console.log("缺少必要的参数，无法获取团队文件列表");
          return;
        }

        // 构建请求参数
        const { page, size } = form_data_pattern;
        const param = {};
        param.page = page;
        param.size = size;
        param.keyword = this.pattern_search_keyword;
        param.team_uuid = curr_team.uuid;
        param.folder_uuid = is_all
          ? folderList[0].uuid
          : curr_second_folder && curr_second_folder.uuid
          ? curr_second_folder.uuid
          : folderList[0].uuid;

        // 请求团队文件列表
        const { code, msg, data } = await teamFileListForDesgin(param);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        console.log("data", data);
        // 更新团队版型列表和总数
        this.team_pattern_list = data && data.list ? data.list : [];
        this.total = data && data.count ? data.count : 0;
      } catch (e) {
        console.log("err-get-team-file-list-design", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      } finally {
        this.is_loading = false;
      }
    },

    // 添加文件到团队资源库
    onAddTeamFile(file) {
      console.log("file", file);
      this.curr_file = file;
      this.show_move_file = true;
    },

    // ---- 团队操作 ----

    // 选择团队
    async onTeamChoose(team) {
      if (!team) return;
      this.curr_team = team;
      // 依次获取文件夹列表和文件列表
      await this.onGetTeamFolderFileList();
      if (this.folder_list[0]) {
        await this.onGetTeamFolderFileList(this.folder_list[0], false, true);
      }
      if (this.secondary_folder_list[0]) {
        await this.onGetTeamFolderFileList(
          this.secondary_folder_list[0],
          true,
          true,
        );
      }
      await this.onGetFileCount();
      await this.onGetTeamFileForDesign();
    },

    // 获取团队文件夹文件列表
    async onGetTeamFolderFileList(
      folder = {},
      is_file = false,
      is_all = false,
    ) {
      try {
        if (!this.curr_team) return;

        // 更新当前选中的二级文件夹
        if (!is_all) {
          this.curr_second_folder = folder;
        } else {
          this.curr_second_folder = {};
        }

        // 如果是文件操作，获取团队文件列表
        if (is_file) {
          this.onGetTeamFileForDesign(false);
        }

        // 构建请求参数
        const param = {};
        param.team_uuid = this.curr_team.uuid;
        param.parent_directory_uuid = folder.uuid || "";

        // 请求文件夹文件列表
        const { code, msg, data } = await teamFolderFileList(param);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }

        // 根据是否有文件夹更新不同的列表
        if (!folder || !folder.uuid) {
          // 更新一级文件夹列表
          this.folder_list = data.filter((item) => item.type == 1);
        } else {
          if (!is_file) {
            // 更新二级文件夹列表
            this.secondary_folder_list = data.filter((item) => item.is_dir);
          }
        }
      } catch (e) {
        console.log("err-get-file-folder-list", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },

    // 获取团队列表
    async onGetTeamList() {
      try {
        this.is_loading = true;
        const { code, msg, data } = await teamList();
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        console.log("data-team-list", data);

        // 处理空数据
        if (!data || !data.length) {
          this.team_list = [];
          this.curr_team = {};
          return;
        }

        // 更新团队列表
        this.team_list = data;
        // 优先选择"所有者"角色的团队，否则选择第一个
        let curr_team = data.filter((item) => item.role === "所有者")[0];
        if (!curr_team) {
          curr_team = data[0];
        }
        this.curr_team = curr_team || {};
      } catch (e) {
        console.log("err-team-list", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      } finally {
        this.is_loading = false;
      }
    },

    // ---- 菜单切换 ----

    // 切换我的版型库菜单
    async onMenuChange(type) {
      // 切换菜单时重置所有筛选条件
      this.pattern_search_keyword = "";
      this.pattern_category_filter = "";
      this.current_history_type = -1;
      this.form_data_pattern.page = 1;
      this.form_data_pattern.keyword = "";
      this.form_data_pattern.sex = 0;
      this.form_data_pattern.pattern_category_id = 0;
      this.pattern_label_ids = [];

      if (type == 1) {
        // 切换到历史版型
        this.onGetHistoryPattern();
      } else {
        // 切换到团队版型
        await this.onGetTeamList();
        if (!this.team_list.length) {
          this.$layer.msg("您还未加入任何团队，请先创建或加入团队");
          return;
        }
        await this.onGetTeamFolderFileList();
        if (this.folder_list[0]) {
          await this.onGetTeamFolderFileList(this.folder_list[0], false, true);
        }
        if (this.secondary_folder_list[0]) {
          await this.onGetTeamFolderFileList(
            this.secondary_folder_list[0],
            true,
            true,
          );
        }
        await this.onGetFileCount();
        await this.onGetTeamFileForDesign();
      }
      // 更新当前菜单
      this.current_pattern_menu = type;
    },

    // ---- 历史版型操作 ----

    // 选择历史版型
    async onChooseHistoryPattern(pattern, is_cancel = false) {
      console.log("history-pattern", pattern);

      // 取消选择
      if (is_cancel) {
        if (pattern.pattern_type == 1) {
          this.cancel_pattern(pattern);
        } else {
          this.reset_pattern();
        }
        this.pattern_source = "";
        return;
      }

      // 如果已选择版型，弹出确认框
      if (this.form_data.pattern_id > 0 || this.form_data.pattern[0]) {
        this.$DModal.confirm({
          content: "是否替换已选版型？",
          onOK: async () => {
            await this.handlePatternSelect(pattern, "history");
          },
        });
      } else {
        // 直接选择
        await this.handlePatternSelect(pattern, "history");
      }
    },

    // 处理版型选择逻辑（抽取公共逻辑）
    async handlePatternSelect(pattern, source) {
      this.pattern_source = source;

      // 根据版型类型处理
      if (pattern.pattern_type == 1) {
        // 平台版型
        this.current_pattern = pattern;
        if (source === "history") {
          console.log("pattern---->", pattern);
        }
        await this.reset_pattern();
        // 传递 style_no_push 参数
        const styleNoPush = source === "history" ? pattern.library_key : pattern.file_key;
        this.confirm_pattern(pattern.pat || pattern, styleNoPush);
      } else if (pattern.pattern_type == 3) {
        // 定制版型
        if (this.form_data.pattern) {
          await this.reset_pattern();
        }
        this.choose_pattern_type(3);
        console.log("pattern_::", pattern);
        // 团队文件来源的字段直接在 pattern 上，历史版型来源的字段在 pattern.pattern 上
        const patternData = source === "team" ? pattern : (pattern.pattern || {});
        this.fill_custom_pattern(
          "c_scene",
          patternData.c_scene || undefined,
        );
        this.fill_custom_pattern(
          "c_type",
          patternData.c_type || undefined,
        );
        this.fill_custom_pattern(
          "sex",
          patternData.sex || undefined,
        );
        this.fill_custom_pattern(
          "difficulty",
          patternData.difficulty || undefined,
        );
        this.fill_custom_pattern2(
          patternData.c_content || undefined,
        );
        if (source === "history") {
          this.fill_custom_pattern("id", pattern ? pattern.id : undefined);
          console.log("this.form_data.pattern", this.form_data.pattern);
        }
        // 关闭定制详情弹窗
        if (this.show_custom_pattern_detail) {
          this.show_custom_pattern_detail = false;
        }
      } else {
        // 客供版型
        await this.reset_pattern();
        // 先设置 pattern_type，但不通过 choose_pattern_type 创建空对象
        this.$store.commit("design/update_common", {
          key: "pattern_type",
          value: 2,
        });
        let object = source === "history" ? pattern.pattern : pattern;
        this.$store.commit("design/update_common", {
          key: "consumption",
          value: pattern.consumption,
        });
        this.$store.commit("design/update_common", {
          key: "consumption2",
          value: pattern.consumption2,
        });
        if (source === "history" && pattern.pattern.guige_path) {
          object.guige_name = pattern.pattern.guige_name;
          object.guige_path = pattern.pattern.guige_path;
        }

        // 处理性别
        let sex;
        if (source === "team") {
          if (isNaN(pattern.sex)) {
            sex = pattern.sex;
          } else {
            sex = pattern.sex == 1 ? "男" : "女";
          }
        } else {
          sex = pattern.sex == 1 ? "男" : "女";
        }
        // 处理早期数据没有files问题
        if (!this.$_.has(object, "files") || !Array.isArray(object.files)) {
          object.files = [];
          if (object.name && object.path) {
            object.files.push({ name: pattern.name, path: object.path });
          }
        }

        this.$store.commit("design/arr_push_one", {
          key: "pattern",
          value: {
            ...object,
            sex,
            id: pattern.id,
          },
        });
        if (this.show_custom_pattern_detail) {
          this.show_custom_pattern_detail = false;
        }
      }

      // 更新历史款号
      // 当从历史版型选择时，推送 pattern.library_key
      // 当从团队版型选择时，推送 pattern.file_key
      if (source === "history") {
        this.$store.commit("design/update_common", {
          key: "style_no_push",
          value: pattern.library_key || "",
        });
        console.log("从历史版型选择，推送 library_key:", pattern.library_key);
      } else {
        this.$store.commit("design/update_common", {
          key: "style_no_push",
          value: pattern.file_key || "",
        });
        console.log("从团队版型选择，推送 file_key:", pattern.file_key);
      }
      console.log("this.form-pattern", this.form_data.pattern);
      // 选择完成后关闭我的版型库
      this.show_my_pattern_library = false;
    },

    // 选择团队文件
    async onTeamFileChoose(pattern, is_cancel = false) {
      if (is_cancel) {
        if (pattern.pattern_type == 1) {
          this.cancel_pattern(pattern);
        } else {
          this.reset_pattern();
        }
        this.pattern_source = "";
        return;
      }

      // 如果已选择版型，弹出确认框
      if (this.form_data.pattern_id > 0 || this.form_data.pattern[0]) {
        this.$DModal.confirm({
          content: "是否替换已选版型？",
          onOK: async () => {
            await this.handlePatternSelect(pattern, "team");
          },
        });
      } else {
        await this.handlePatternSelect(pattern, "team");
      }
    },

    // ---- 定制版型操作 ----

    // 取消定制版型详情
    onCancelCustomDetail() {
      this.current_pattern = {
        image_list: [],
      };
      this.show_custom_pattern_detail = false;
    },

    // ---- 文件查看 ----

    // 下载文件
    async onDownloadFile(file) {
      if (!file) {
        this.$layer.msg('无可下载文件');
        return;
      }
      try {
        const response = await fetch(file);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const fileName = file.split('/').pop().split('?')[0] || 'download';
        link.download = decodeURIComponent(fileName);
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载文件时出错:', error);
        this.$layer.msg('下载失败，请稍后重试');
      }
    },

    // 查看历史版型详情
    async onHistoryPatternView(data) {
      if (data.pattern_type == 1) {
        // 平台版型，打开详情弹窗
        this.open_pattern_detail(data);
      } else {
        // 其他版型，显示定制详情
        this.current_pattern = data;
        this.show_custom_pattern_detail = true;
      }
    },

    // 查看团队文件详情
    onTeamFileView(data) {
      const { info, pattern } = data;
      if (info.pattern_type == 1) {
        // 平台版型
        this.open_pattern_detail(pattern);
      } else {
        // 其他版型
        this.current_pattern = { pattern: data.info };
        this.show_custom_pattern_detail = true;
      }
    },

    // ---- 数据获取 ----

    // 获取历史版型列表
    async onGetHistoryPattern() {
      try {
        this.is_loading = true;
        const { current_history_type } = this;
        this.total = -1;

        // 构建请求参数
        const param = {};
        param.pattern_type =
          current_history_type < 0 ? 0 : current_history_type;
        // 使用表单配置的分页大小，或者默认15条
        param.size = this.form_data_pattern.size || 15;
        
        // 添加搜索关键词
        if (this.pattern_search_keyword) {
          param.keyword = this.pattern_search_keyword;
        }
        
        // 添加类别筛选
        if (this.pattern_category_filter) {
          param.category = this.pattern_category_filter;
        }

        // 请求历史版型
        const { data } = await getPatternHistory({
          ...this.form_data_pattern,
          ...param,
        });
        this.total = data.count;
        this.history_pattern_list = data.list;
      } catch (e) {
        console.log("err-history-pattern", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      } finally {
        this.is_loading = false;
      }
    },

    // ---- 标签操作 ----

    // 选择/取消标签
    choose_label(v) {
      if (this.pattern_label_ids.includes(v.id)) {
        // 已选中，取消选中
        this.pattern_label_ids = this.pattern_label_ids.filter((item) => {
          return item !== v.id;
        });
      } else {
        // 未选中，添加选中
        this.pattern_label_ids.push(v.id);
        this.pattern_label_ids = [...new Set(this.pattern_label_ids)];
      }
      // 重置页码并重新获取版型列表
      this.form_data_pattern.page = 1;
      this.getPatternList();
    },

    // ---- 表格操作 ----

    // 获取版型字段名称
    getPatternName(field_key) {
      const { field_list } = this.current_pattern;
      const data = field_list.find((item) => item.field_key === field_key);
      console.log("data====>", data);
      return data ? data.field_name_cn : "";
    },

    // 生成版型尺寸表格数据
    generateTableData(partList, sizeList, sizeInfo) {
      const result = [];

      // 校验 sizeList
      if (!Array.isArray(sizeList) || sizeList.length === 0) {
        return result;
      }

      // 遍历尺码
      for (const sizeKey of sizeList) {
        let size = "";

        // 处理不同类型的 sizeKey
        if (typeof sizeKey === "string") {
          size = sizeKey;
        } else if (typeof sizeKey === "number") {
          size = String(sizeKey);
        } else if (Array.isArray(sizeKey)) {
          size = String(sizeKey[0]);
        } else if (typeof sizeKey === "object" && sizeKey !== null) {
          const keys = Object.keys(sizeKey);
          if (keys.length > 0) {
            size = String(keys[0]);
          }
        } else {
          console.warn("Unexpected sizeKey type:", typeof sizeKey, sizeKey);
          continue;
        }

        const sizeData = sizeInfo[size];

        // 构建行数据
        const row = {
          size: size,
        };

        // 填充各部位数据
        for (const part of partList) {
          if (sizeData && sizeData[part]) {
            row[part] = {
              normal: sizeData[part].normal,
              min: sizeData[part].min,
              max: sizeData[part].max,
            };
          } else {
            row[part] = {
              normal: "",
              min: "",
              max: "",
            };
          }
        }

        result.push(row);
      }

      return result;
    },

    // ---- 定制版型填充 ----

    // 填充定制版型字段
    fill_custom_pattern(field, content) {
      console.log("form_pattern", this.form_data.pattern);
      let object = this.form_data.pattern[0] || {};
      console.log("object", object);
      object[field] = content;
      // 清空并重新设置 pattern
      this.$store.commit("design/update_common", { key: "pattern", value: [] });
      this.$store.commit("design/arr_push_one", {
        key: "pattern",
        value: object,
      });
    },

    // 填充定制版型内容（处理输入事件）
    fill_custom_pattern2(e) {
      let object = this.form_data.pattern[0] || {};
      object.c_content = e && e.target ? e.target.value : e;
      this.$store.commit("design/update_common", { key: "pattern", value: [] });
      this.$store.commit("design/arr_push_one", {
        key: "pattern",
        value: object,
      });
    },

    // ---- 通用操作 ----

    // 打开新窗口
    open_window(path) {
      if (!path) return;
      window.open(path, "_blank");
    },

    // 选择版型类型
    choose_pattern_type(type) {
      if(this.form_data.pattern_type > 0 && this.form_data.pattern_type != type){
        // 如果没有填写版型数据，直接切换不弹确认提示
        const hasPatternData = this.form_data.pattern && this.form_data.pattern.length > 0 && this.form_data.pattern.some(p => p && Object.keys(p).length > 0);
        if (!hasPatternData) {
          // 切换到平台版型时，清空 pattern 数组
          if (type === 1) {
            this.$store.commit("design/update_common", { key: "pattern", value: [] });
          }
          this.$store.commit("design/update_common", {
              key: "pattern_type",
              value: type,
          });
          if((type === 2 || type === 3) && (!this.form_data.pattern || this.form_data.pattern.length === 0)){
            this.$store.commit("design/arr_push_one", {
              key: "pattern",
              value: {},
            });
          }
          return;
        }
        this.$DModal.confirm({
          content: "此操作会清空之前版型数据，确定要切换当前版型类型吗？",
          onOK: async () => {
            await this.reset_pattern();
            // 切换版型类型时关闭我的版型库
            this.show_my_pattern_library = false;
            this.$store.commit("design/update_common", {
                key: "pattern_type",
                value: type,
            });
            // 客供版型和定制服务需要创建一个空的版型数据对象
            if((type === 2 || type === 3) && (!this.form_data.pattern || this.form_data.pattern.length === 0)){
              this.$store.commit("design/arr_push_one", {
                key: "pattern",
                value: {},
              });
            }
          },
        })
      }else{
        this.$store.commit("design/update_common", {
            key: "pattern_type",
            value: type,
        });
        // 客供版型和定制服务需要创建一个空的版型数据对象
        if((type === 2 || type === 3) && (!this.form_data.pattern || this.form_data.pattern.length === 0)){
          this.$store.commit("design/arr_push_one", {
            key: "pattern",
            value: {},
          });
        }
      }
      
    },

    // 分页切换
    changePage(page) {
      const { current_pattern_type, current_pattern_menu } = this;
      this.form_data_pattern.page = page;

      // 根据当前类型和菜单获取数据
      if (current_pattern_type == 2 && current_pattern_menu == 2) {
        this.onGetTeamFileForDesign();
        return;
      }
      if (current_pattern_type == 2 && current_pattern_menu == 1) {
        this.onGetHistoryPattern();
        return;
      }
      this.getPatternList();
    },

    // 输入框输入
    input1($event, field) {
      this.$store.commit("design/update_common", {
        key: field,
        value: $event.target.value,
      });
    },

    // 搜索版型
    search_pattern() {
      const { current_pattern_type, current_pattern_menu } = this;

      // 根据当前类型和菜单获取数据
      if (current_pattern_type == 2 && current_pattern_menu == 2) {
        this.onGetTeamFileForDesign();
        return;
      }
      if (current_pattern_type == 2 && current_pattern_menu == 1) {
        this.onGetHistoryPattern();
        return;
      }
      this.getPatternList();
    },

    // 打开版型详情
    open_pattern_detail(pattern) {
      console.log("pattern_detail", pattern);
      this.current_pattern = pattern;
      const patternData = pattern.pat || pattern;
      // 生成表格数据
      this.table_data = this.generateTableData(
        patternData.part_list,
        patternData.size_list,
        patternData.size_info,
      );
      console.log(this.table_data, "<===tableData");
      this.is_popup_show_detail = true;
      // 每次打开详情弹窗时滚动到顶部
      this.$nextTick(() => {
        const el = this.$refs.detailPopupContent;
        if (el) el.scrollTop = 0;
      });
    },

    // 切换版型选择/取消
    toggle_pattern(pattern) {
      console.log("toggle_pattern", pattern);
      if (this.form_data.pattern_id === pattern.id) {
        this.cancel_pattern(pattern);
      } else {
        // 传递 style_no_push 参数
        const styleNoPush = pattern.library_key || pattern.file_key || "";
        this.confirm_pattern(pattern, styleNoPush);
      }
      // 关闭详情弹窗
      if (this.is_popup_show_detail) {
        this.is_popup_show_detail = false;
      }
    },

    // 处理从 localStorage 读取的版型数据
    processSelectedPattern(pattern) {
      console.log("processSelectedPattern", pattern);

      // 判断版型类型并处理
      if (pattern.id && !pattern.info) {
        // 平台版型（有 id 字段，但没有 info 字段）
        this.processPlatformPattern(pattern);
      } else if (pattern.info) {
        // 团队版型（有 info 字段）
        this.processTeamPattern(pattern);
      } else if (pattern.pattern_number || pattern.name) {
        // 从详情页跳转的版型
        this.processCustomPattern(pattern);
      }
    },

    // 处理平台版型
    processPlatformPattern(pattern) {
      this.confirm_pattern(pattern);
    },

    // 处理团队版型
    processTeamPattern(pattern) {
      // 直接使用团队版型的数据结构
      const teamPattern = pattern;
      this.onTeamFileChoose(teamPattern);
    },

    // 处理自定义版型（从详情页跳转）
    processCustomPattern(pattern) {
      console.log("处理自定义版型:", pattern);

      // 先重置版型
      this.reset_pattern();

      // 选择自定义版型类型
      this.choose_pattern_type(2);

      // 判断是否为平台版型（有 id 字段）
      if (pattern.id) {
        // 这是平台版型，直接使用 confirm_pattern
        this.confirm_pattern(pattern);
        return;
      }

      // 构建自定义版型数据结构
      let patternObj = {
        files: [],
        sex: pattern.sex,
        consumption: pattern.consumption,
        consumption2: pattern.consumption2,
      };

      // 添加版型文件
      if (pattern.path) {
        patternObj.files.push({
          name: pattern.name || pattern.pattern_number || "版型文件",
          path: pattern.path,
        });
      }

      // 添加规格表文件
      if (pattern.guige_path) {
        patternObj.guige_name = pattern.guige_name;
        patternObj.guige_path = pattern.guige_path;
      }

      // 如果没有文件但有 main_image，使用 main_image
      if (patternObj.files.length === 0 && pattern.main_image) {
        patternObj.files.push({
          name: pattern.pattern_number || "版型预览",
          path: pattern.main_image,
        });
      }

      // 更新到 store
      this.$store.commit("design/arr_push_one", {
        key: "pattern",
        value: patternObj,
      });

      // 更新耗量信息
      this.$store.commit("design/update_common", {
        key: "consumption",
        value: pattern.consumption || 0,
      });
      this.$store.commit("design/update_common", {
        key: "consumption2",
        value: pattern.consumption2 || 0,
      });

      // 更新性别信息
      if (pattern.sex !== undefined) {
        // 这里需要设置性别选择逻辑
        // 先设置一个默认值，或者通过其他方式处理
        if (this.form_data.pattern && this.form_data.pattern.length > 0) {
          this.$store.commit("design/arr_update_one", {
            key: "pattern",
            index: 0,
            value: { ...this.form_data.pattern[0], sex: pattern.sex },
          });
        }
      }

      console.log("自定义版型已设置:", patternObj);
    },

    // 确认选择版型
    confirm_pattern(pattern, styleNoPush) {
      console.log("pattern-confirm", pattern);
      if (this.form_data.pattern_id > 0) {
        // 已选择版型，弹出确认框
        this.$DModal.confirm({
          content: "是否替换已选版型？",
          onOK: async () => {
            this.push_pattern(pattern, styleNoPush);
          },
        });
      } else {
        // 直接选择
        this.push_pattern(pattern, styleNoPush);
      }
    },

    // 提交版型
    push_pattern(pattern, styleNoPush) {
      this.pattern_source = "platform";
      console.log("pattern___package", pattern);
      this.curr_sex = pattern.sex;
      // 更新包装明细
      if (
        pattern &&
        pattern.package_detail &&
        pattern.package_detail.length > 0
      ) {
        this.$store.commit("design/update_common", {
          key: "package_detail",
          value: pattern.package_detail,
        });
      }

      // 重置版型
      this.reset_pattern();
      this.choose_pattern_type(1);

      // 关闭我的版型库
      this.show_my_pattern_library = false;

      // 更新版型信息
      const patternId = pattern.pattern_id || pattern.id;
      this.$store.commit("design/update_common", {
        key: "pattern_id",
        value: patternId,
      });
      this.$store.commit("design/update_common", {
        key: "consumption",
        value: pattern.consumption,
      });
      this.$store.commit("design/update_common", {
        key: "consumption2",
        value: pattern.consumption2,
      });

      // 设置历史款号
      if (styleNoPush !== undefined) {
        this.$store.commit("design/update_common", {
          key: "style_no_push",
          value: styleNoPush,
        });
      }

      // 构建版型对象
      let object = {
        image: pattern.main_image,
        name: pattern.pattern_number,
        path: "",
        guige_name: "",
        guige_path: "",
      };
      object.id = pattern.pattern_id || pattern.id;

      // 更新 pattern
      this.$store.commit("design/arr_push_one", {
        key: "pattern",
        value: object,
      });
      console.log("form_data after push:", JSON.parse(JSON.stringify(this.form_data)));
    },

    // 取消选择版型
    cancel_pattern(pattern) {
      this.$DModal.confirm({
        content: "是否取消已选版型？",
        onOK: async () => {
          // 清空包装明细
          if (pattern.package_detail && pattern.package_detail.length > 0) {
            this.$store.commit("design/update_common", {
              key: "package_detail",
              value: [],
            });
          }
          // 重置版型
          this.reset_pattern();
        },
      });
    },

    // 重置版型
    reset_pattern() {
      this.pattern_source = "";
      this.$store.commit("design/update_common", {
        key: "pattern_type",
        value: 0,
      });
      this.$store.commit("design/update_common", {
        key: "pattern_id",
        value: 0,
      });
      this.$store.commit("design/update_common", {
        key: "consumption",
        value: 0,
      });
      this.$store.commit("design/update_common", {
        key: "consumption2",
        value: 0,
      });
      this.$store.commit("design/update_common", {
        key: "style_no_push",
        value: "",
      });
      this.$store.commit("design/update_common", { key: "pattern", value: [] });
    },

    // 使用定制版型
    use_custom_pattern() {
      this.reset_pattern();
      this.choose_pattern_type(3);
      let object = {
        image: "",
        name: "",
        path: "",
        guige_name: "",
        guige_path: "",
        c_scene: "",
        c_type: "",
      };
      this.$store.commit("design/arr_push_one", {
        key: "pattern",
        value: object,
      });
    },

    // 选择版型分类
    choose_pattern_category(category) {
      this.current_pattern_category_id =
        this.form_data_pattern.pattern_category_id =
          category.pattern_category_id;
      this.getPatternList();
    },

    // 选择版型性别
    choose_pattern_sex(sex) {
      this.form_data_pattern.sex = sex;
      this.getPatternList();
    },

    // 打开版型选择弹窗
    async open_pattern_modal() {
      this.$store.commit("design/hide_lesson");
      if (this.form_data.pattern_type && this.form_data.pattern_type != 1) {
        // 非平台版型，弹出确认框
        this.$DModal.confirm({
          content: "将会清空已填写版型数据,是否继续?",
          onOK: async () => {
            this.reset_pattern();
            this.choose_pattern_type(1);
            await this.getPatternList();
          },
        });
      } else {
        // 已经是平台版型，直接获取列表
        this.choose_pattern_type(1);
        await this.getPatternList();
      }
    },

    // ---- 文件管理 ----

    // 删除自定义文件
    del_self_file(k) {
      let object = this.form_data.pattern[0];
      object.files.splice(k, 1);
      // 更新 pattern
      this.$store.commit("design/arr_update_one", {
        key: "pattern",
        index: 0,
        value: object,
      });
    },

    // 删除规格文件
    del_guige_file() {
      let object = this.form_data.pattern[0];
      object.guige_name = "";
      object.guige_path = "";
      // 清空并重新设置 pattern
      this.$store.commit("design/update_common", { key: "pattern", value: [] });
      this.$store.commit("design/arr_push_one", {
        key: "pattern",
        value: object,
      });
    },

    // ---- 数据获取 ----

    // 获取版型分类列表
    async getPatternCategoryList() {
      this.is_loading = true;
      return PatternCategoryList().then((response) => {
        this.pattern_category_list = [
          { category_name: "全部", pattern_category_id: 0 },
          ...response.data,
        ];
        this.is_loading = false;
        return response;
      });
    },

    // 获取版型标签列表
    async getPatternLabelList() {
      this.is_loading = true;
      return PatternLabelList()
        .then((response) => {
          this.pattern_label_list = [...response.data];
          this.is_loading = false;
          return response;
        })
        .catch((err) => {
          console.log("err", err);
          this.is_loading = false;
        });
    },

    // 获取版型列表
    async getPatternList() {
      // 增加请求 ID，用于防止竞态
      this.pattern_list_request_id = (this.pattern_list_request_id || 0) + 1;
      const current_request_id = this.pattern_list_request_id;

      const parent_id = this.$store.state.design.form_data.parent_product_category_id;
      const child_id = this.$store.state.design.form_data.child_product_category_id;

      this.is_loading = true;
      this.pattern_list = [];

      try {
        const response = await PatternList({
          ...this.form_data_pattern,
          label_id: this.pattern_label_ids,
          first_product_category_id: parent_id,
          second_product_category_id: child_id,
        });

        // 检查是否是最新请求，如果不是则丢弃响应
        if (current_request_id !== this.pattern_list_request_id) {
          return;
        }

        const list = response.data.list || [];
        const pattern_list = list.map((item) => {
          let isLastUsed = false;
          if (item && typeof item === 'object') {
            const val = item.is_last_used;
            isLastUsed = val === true || val === 'true' || val === 1 || val === '1';
          }
          return {
            ...(item || {}),
            is_last_used: isLastUsed
          };
        });
        this.pattern_list = pattern_list;
        this.total = response.data.total;
        this.is_loading = false;
      } catch (err) {
        // 检查是否是最新请求
        if (current_request_id !== this.pattern_list_request_id) {
          return;
        }
        console.log("err", err);
        this.is_loading = false;
      }
    },

    // ---- 文件上传 ----

    // 上传前处理
    onBeforeUploadPattern(file, field, scene) {
      uploadFileToOSS(file, "template").then((url) => {
        if (field === "path" && scene === "self") {
          // 自定义文件上传
          if (!util.is_pattern_file(file.name)) {
            // const fileType = [
            //   'pjh','plt','boke','prj','ets','dgs','pds','fgs','gmt','bpd','gph',
            //   'tmp','zip','mdl','pa1','pa2','pa3','pat','sty','sg','jit','ftd',
            //   'sak','skc','aud','pdt','pan','pax','dxf','aama','inv'
            // ];
            this.$layer.msg(`请上传符合规格的版型文件`);
            return false;
          }
          // 首次上传
          let object = {
            name: file.name,
            path: url,
            guige_name: "",
            guige_path: "",
            files: [],
          };
          if (this.form_data.pattern_type != 2) {
            // 非客供版型，重置并切换
            this.reset_pattern();
            this.choose_pattern_type(2);
          } else {
            // 已是客供版型，获取当前对象
            object = this.form_data.pattern[0];
            // 早期数据判断
            if (!this.$_.has(object, "files") || !Array.isArray(object.files)) {
              object.files = [];
              if (object.name && object.path) {
                object.files.push({ name: object.name, path: object.path });
              }
            }
          }
          if(object.files.length >= 3){
            this.$layer.msg('客供版型最多上传3个文件');
            return false;
          }
          object[`name`] = file.name;
          object[`url`] = url;
          object.files.push({ name: file.name, path: url });
          // 更新 pattern
          this.$store.commit("design/arr_update_one", {
            key: "pattern",
            index: 0,
            value: object,
          });
          console.log('form_data',this.form_data);
        } else if (field === "path" && scene === "custom") {
          // 定制文件上传
          let currentPattern =
            this.form_data.pattern && this.form_data.pattern.length > 0
              ? this.form_data.pattern[0]
              : {};
          let object = {
            ...currentPattern,
            name: file.name,
            path: url,
          };
          if (this.form_data.pattern && this.form_data.pattern.length > 0) {
            // 更新现有 pattern
            this.$store.commit("design/arr_update_one", {
              key: "pattern",
              index: 0,
              value: object,
            });
          } else {
            // 添加新 pattern
            this.$store.commit("design/arr_push_one", {
              key: "pattern",
              value: object,
            });
          }
        } else if (field === "guige") {
          // 规格文件上传
          let object = this.form_data.pattern[0];
          object.guige_name = file.name;
          object.guige_path = url;
          // 清空并重新设置 pattern
          this.$store.commit("design/update_common", {
            key: "pattern",
            value: [],
          });
          this.$store.commit("design/arr_push_one", {
            key: "pattern",
            value: object,
          });
        }
      });
      return false;
    },
    input2($event, field, k, child_field) {
      const newValue = $event.target.value;
      // console.log('event',$event,'newVal',newValue);
      const originalItem = this.form_data[field][k];
      let updatedItem = { ...originalItem, [child_field]: newValue };
      this.$store.commit("design/arr_update_one", {
        key: field,
        index: k,
        value: updatedItem,
      });
    },
    del_child(k) {
      this.$store.commit("design/arr_remove_one", {
        key: "children",
        index: k,
      });
    },
    add_child() {
      let object = {
        key: util.uuid(),
        name: "",
      };
      this.$store.commit("design/arr_push_one", {
        key: "children",
        value: object,
      });
    },
    toggle_multi() {
      this.$store.commit("design/update_common", {
        key: "is_multiple",
        value: !this.form_data.is_multiple,
      });
    },
    set_image(obj) {
      if (typeof obj === "object") {
        this.main_file = obj;
        // 同步更新 store 中的 image 字段
        this.$store.commit("design/update_common", {
          key: "image",
          value: obj.raw,
        });
      } else {
        this.main_file = {
          raw: obj,
          raw_name: "",
        };
        // 同步更新 store 中的 image 字段
        this.$store.commit("design/update_common", {
          key: "image",
          value: obj,
        });
      }
    },
    change1(value, field) {
      switch (field) {
        case "parent_product_category_id": {
          const find_index = this.product_category_list.findIndex(
            (item) => Number(item.product_category_id) === Number(value),
          );
          if (find_index != -1) {
            this.curr_package_detail =
              this.product_category_list[find_index].package_detail || [];
            this.$store.commit("design/update_common", {
              key: "package_detail",
              value: this.curr_package_detail,
            });
          }
          break;
        }
        case "child_product_category_id": {
          const find_index = this.sub_product_category_list.findIndex(
            (item) => Number(item.product_category_id) === Number(value),
          );
          if (find_index != -1) {
            if (
              this.sub_product_category_list[find_index].package_detail &&
              this.sub_product_category_list[find_index].package_detail.length >
                0
            ) {
              this.package_detail =
                this.sub_product_category_list[find_index].package_detail;
              this.$store.commit("design/update_common", {
                key: "package_detail",
                value: this.curr_package_detail,
              });
            }
          }
          break;
        }
      }
      console.log("package_detail", this.form_data.package_detail);
      this.$store.commit("design/update_common", {
        key: field,
        value: parseInt(value),
      });
    },
    // Cascader 选择变化
    on_cascader_change(value) {
      console.log('value---->',value);
      if (value && value.length > 0) {
        // 有选择值
        const parent_id = value[0];
        const child_id = value.length > 1 ? value[1] : 0;
        console.log('parent:',parent_id,'child:', child_id);
        // 调用原有的 change1 方法处理父分类
        this.change1(parent_id, "parent_product_category_id");

        // 如果有子分类，延迟到父级 watcher 执行完后再设置子分类
        // 避免父级 watcher 中 oldVal>0 时重置 child_product_category_id=0 覆盖已设置的子级 ID
        if (child_id > 0) {
          this.$nextTick(() => {
            this.change1(child_id, "child_product_category_id");
          });
        }

        // 设置 product_category_id（取最具体的分类：有子类用子类，没有用父类）
        this.$store.commit("design/update_common", {
          key: "product_category_id",
          value: parseInt(child_id > 0 ? child_id : parent_id),
        });

        // 品类选择完成后，自动打开版型选择弹窗（弹窗内会加载版型列表）
        this.$nextTick(() => {
          this.open_pattern_modal();
        });
      } else {
        // 清空选择
        this.$store.commit("design/update_common", {
          key: "parent_product_category_id",
          value: 0,
        });
        this.$store.commit("design/update_common", {
          key: "child_product_category_id",
          value: 0,
        });
        this.$store.commit("design/update_common", {
          key: "product_category_id",
          value: 0,
        });
      }

      console.log('form-data',this.form_data);
    },
    handleDragStart(event, draggedIndex) {
      event.dataTransfer.setData("draggedIndex", draggedIndex);
    },
    handleDrop(event, targetIndex) {
      event.preventDefault();
      const draggedIndex = event.dataTransfer.getData("draggedIndex");
      if (draggedIndex === targetIndex) return;
      let image_list = this.form_data.image_list;
      const draggedItem = image_list.splice(draggedIndex, 1)[0];
      image_list.splice(targetIndex, 0, draggedItem);
      this.$store.commit("design/update_common", {
        key: "image_list",
        value: image_list,
      });
    },
    del_img(k) {
      this.$store.commit("design/arr_remove_one", {
        key: "image_list",
        index: k,
      });
      let len = this.form_data.image_list.length;
      console.log(111, len);
      if (len === 0) {
        this.main_file = { raw: "", raw_name: "" };
      } else {
        if (typeof this.form_data.image_list[0] === "object") {
          this.main_file = this.form_data.image_list[0];
        } else {
          this.main_file = {
            raw: this.form_data.image_list[0],
            raw_name: "",
          };
        }
      }
    },
    onBeforeUpload(file, field) {
      if (this.form_data.image_list.length >= 15) {
        this.$layer.msg(`最多可添加15张设计图`);
        return;
      }
      uploadFileToOSS(file, "template").then((url) => {
        if (field === "image_list") {
          let object = {};
          object.raw = url;
          object.raw_name = file.name;
          this.$store.commit("design/arr_push_one", {
            key: "image_list",
            value: object,
          });
          if (this.form_data.image_list.length === 1) {
            this.main_file = object;
            // 如果是第一个图片，同步到 form_data.image
            this.$store.commit("design/update_common", {
              key: "image",
              value: url,
            });
          }
        }
      });
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.manuscript {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: visible;

  .main-form {
    width: 488px;
    height: 100%;
    overflow-y: auto;
    padding: 30px;
    background: #fff;
    border-right: 1px solid #f0f0f0;
    flex-shrink: 0;

    &::-webkit-scrollbar {
      display: none;
    }

    .main-form-title {
      color: #000;
      font-size: 18px;
      display: flex;
      align-items: center;
      column-gap: 10px;
      line-height: 18px;
      font-weight: bold;

      &::before {
        content: "";
        width: 2px;
        height: 18px;
        line-height: 18px;
        background: #000;
      }

      &.mt-40 {
        margin-top: 40px;
      }
    }

    .form-category {
      width: 100%;
      display: flex;
      column-gap: 10px;
      align-items: center;
      margin-top: 30px;

      .ivu-cascader {
        width: 100%;
      }
    }

    .main-image {
      width: 100%;
      height: 421px;
      margin-top: 25px;
      border-radius: 5px;
      border: 1px dashed #b3b3b3;

      &:hover {
        border: 1px dashed skyblue;
      }

      .upload-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        .icon-upload {
          width: 52px;
          height: 60px;
        }

        p {
          width: 100%;
          color: #4d4f52;
          font-size: 14px;
          margin-top: 26px;
          text-align: center;
        }
      }

      ::v-deep .ivu-upload {
        width: 100%;
        height: 100%;
        border: none;
      }

      .icon-doc {
        width: 50px;
        height: 50px;
      }
    }

    .image-list {
      width: 100%;
      display: flex;
      align-items: center;
      column-gap: 10px;
      flex-wrap: wrap;
      margin-top: 20px;
      margin-bottom: 40px;

      .image-item {
        width: 60px;
        height: 60px;
        border: 1px solid #b3b3b3;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        row-gap: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        span {
          width: 60px;
          height: 15px;
          text-align: center;

          &:first-child {
            font-size: 20px;
          }

          &:last-child {
            font-size: 12px;
          }
        }

        .icon-close {
          position: absolute;
          width: 15px;
          height: 15px;
          top: 0;
          right: 0;
          z-index: 10;
        }

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .multiple-wrap {
      display: flex;
      align-items: center;
      margin: 10px 0;

      .icon-check {
        width: 20px;
        height: 20px;
      }

      span {
        margin: 0 5px;
      }
    }

    .multiple-form {
      width: 100%;
      border: 1px solid #d1d1d1;
      padding: 15px 15px 20px 15px;

      .multiple-tips {
        color: #999;
        font-size: 14px;
      }

      .multiple-form-body {
        width: 100%;
        background: #fff;
        padding: 20px 11px 20px 14px;
        display: flex;
        flex-direction: column;
        row-gap: 10px;

        .multiple-item {
          display: flex;
          align-items: center;
          column-gap: 10px;

          .item-label {
            color: #4d4d4d;
            font-size: 14px;
            flex-shrink: 0;
          }

          .btn-del {
            width: 24px;
            height: 24px;
            cursor: pointer;
          }
        }

        .btn-add {
          width: 100%;
          height: 35px;
          line-height: 35px;
          color: #666666;
          font-size: 14px;
          text-align: center;
          margin: 10px 0;
          border-radius: 10px;
          border: 1px solid #ccc;
          cursor: pointer;
        }
      }
    }

    .main-form-textarea {
      resize: none;
      border: 1px solid #d1d1d1;
      border-radius: 5px;
      margin-top: 16px;
      width: 100%;
      height: 180px;
      padding: 15px;
      background: #f8f9fc;
      outline: none;
    }
  }

  .main-content {
    flex: 1 0 auto;
    min-width: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .pattern-type-box {
      width: 100%;
      background: #fff;
      padding: 15px 24px;
      display: flex;
      align-items: center;
      column-gap: 24px;

      .box-title {
        color: #000;
        font-size: 18px;
        font-weight: 500;
        display: flex;
        align-items: center;
        flex-shrink: 0;

        &::before {
          content: "";
          width: 2px;
          height: 18px;
          background: #000;
          display: inline-block;
          margin-right: 13px;
        }
      }

      .pattern-type-item {
        display: flex;
        align-items: center;
        column-gap: 15px;
        padding: 5px 16px;
        border: 1px solid #e3e3e3;
        border-radius: 8px;
        cursor: pointer;
        flex-shrink: 0;

        &.active {
          background: #fff6f7;
          border: 1px solid #ff5967;
        }

        .item-left {
          display: flex;
          align-items: center;
          column-gap: 6px;
          color: #333;
          font-size: 12px;

          .type-icon {
            width: 22px;
            height: 22px;
          }
        }

        input[type="radio"] {
          appearance: none;
          -webkit-appearance: none;
          width: 15px;
          height: 15px;
          border: 2px solid #ccc;
          border-radius: 50%;
          outline: none;
          cursor: pointer;
          position: relative;
          flex-shrink: 0;

          &.radio-checked {
            border-color: #ff4d4f;
            background: #ff4d4f;

            &::after {
              content: "";
              position: absolute;
              top: 50%;
              left: 50%;
              width: 5px;
              height: 10px;
              border: solid white;
              border-width: 0 2.5px 2.5px 0;
              transform: translate(-50%, -60%) rotate(45deg);
            }
          }
        }
      }

      .toggle-my-pattern-btn {
        padding: 5px 10px;
        border: 1px solid #e3e3e3;
        border-radius: 8px;
        cursor: pointer;
        flex-shrink: 0;
        color: #666;
        font-size: 12px;
        background: #f5f5f5;
        transition: all 0.3s;

        &.active {
          background: #fff6f7;
          color: #ff5967;
          border-color: #ff5967;
        }

        &:hover {
          border-color: #1890ff;
        }
      }
    }

    .pattern-content-box {
      flex: 1;
      max-width: 1200px;
      padding: 10px 65px 20px 10px;
      display: flex;
      flex-direction: column;
      row-gap: 16px;
      min-height: 0;

      .pattern-selected-box {
        width: 100%;
        border: 1px solid #e3e3e3;
        background: #fff;
        border-radius: 6px;
        padding: 10px 20px;
        position: relative;
        display: flex;
        flex-direction: column;
        row-gap: 20px;

        .close-icon {
          position: absolute;
          top: 10px;
          right: 10px;
          color: #999;
          font-size: 14px;
          cursor: pointer;
        }

        .selected-box-title {
          display: flex;
          align-items: center;
          column-gap: 8px;

          .selected-title-info {
            color: #333;
            font-size: 16px;
            font-weight: 500;
          }

          .selected-title-tag {
            color: #333;
            font-size: 12px;
            padding: 2px 8px;
            border-radius: 4px;
            border: 1px solid #e3e3e3;
            user-select: none;
          }
        }

        .select-pattern-info {
          display: flex;
          align-items: center;
          column-gap: 12px;

          .pattern-img {
            width: 59px;
            height: 59px;
            border: 1px solid #e3e3e3;
            border-radius: 8px;
            object-fit: cover;
          }

          .pattern-info-item-list {
            display: flex;
            align-items: center;
            column-gap: 56px;

            .pattern-info-item {
              display: flex;
              flex-direction: column;
              row-gap: 3px;
              flex-shrink: 0;

              .info-item-label {
                color: #666;
                font-size: 14px;

                &.name-info {
                  color: #000;
                  font-weight: 500;
                }
              }

              .info-item-value {
                color: #666;
                font-size: 14px;
              }
            }
          }
        }
      }

      .content-body {
        width: 100%;
        flex: 1;
        min-height: 0;
        background: #fff;
        display: flex;
        flex-direction: column;
        overflow-y:auto;

        .top {
          display: flex;
          justify-content: space-between;
          padding: 14px 20px;
          border-bottom: 2px solid #f6f7fa;
          flex-shrink: 0;

          .title-box {
            display: flex;
            align-items: center;
            column-gap: 28px;

            .title-item {
              color: #b3b3b3;
              font-size: 16px;
              cursor: pointer;

              &.active {
                color: #1a1a1a;
                font-size: 20px;
                font-weight: bold;
              }
            }

            .line {
              width: 1px;
              height: 16px;
              background: #b3b3b3;
            }
          }

          h2 {
            font-size: 20px;
            color: #1a1a1a;
            white-space: nowrap;
          }

          .input-wrap {
            margin-left: 50px;
            width: 280px;
            height: 35px;
            position: relative;

            &:focus {
              border: none !important;
            }

            &::after {
              border: none !important;
            }

            input {
              width: 100%;
              height: 100%;
              background: #f2f2f2;
              border-radius: 17px;
              padding: 0 45px 0 20px;
              border: none !important;

              &:focus {
                border: none !important;
              }

              &::after {
                border: none !important;
              }
            }

            .icon-search {
              position: absolute;
              right: 18px;
              top: 50%;
              transform: translateY(-50%);
              width: 20px;
              height: 20px;
              cursor: pointer;
            }
          }
        }

        .content-container {
          width: 100%;
          height: 100%;
          min-height: 0;
          flex: 1;
          display: flex;
          position: relative;

          .side-category-list {
            flex: 0 0 139px;
            height: 100%;
            overflow-y: auto;
            padding: 0 20px;
            padding-top: 9px;
            border-right: 1px solid #f6f7fa;

            .category-item {
              width: 100%;
              height: 35px;
              line-height: 35px;
              font-size: 14px;
              color: #1c1c1c;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              cursor: pointer;
              padding-left: 19px;

              &.active {
                background: #1c1c1c;
                border-radius: 5px;
                color: #fff;
              }
            }
          }

          .my-pattern-menu {
            flex: 1;
            max-width: 198px;
            height: 100%;
            display: flex;
            flex-direction: column;
            row-gap: 10px;
            padding: 0 20px;
            margin-top: 9px;

            .menu-parent-item {
              width: 100%;
              height: 35px;
              display: flex;
              align-items: center;
              column-gap: 10px;
              color: #1c1c1c;
              font-size: 14px;
              padding-left: 10px;
              padding-right: 4px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              cursor: pointer;

              &.active {
                background: #1c1c1c;
                border-radius: 5px;
                color: #ffffff;
              }

              .menu-icon {
                width: 20px;
                height: 20px;
              }

              .label-name {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: space-between;
              }
            }

            ul {
              margin-left: 39px;

              li {
                list-style-type: square;
                position: relative;
                cursor: pointer;
                color: #4d4d4d;
                font-size: 14px;
                line-height: 40px;

                span {
                  display: block;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  width: 100%;
                }

                &::marker {
                  font-size: 18px;
                }

                &:hover,
                &.active-team {
                  color: #ff5967;
                }
              }
            }
          }

          /* 历史版型标签 */
          .history-tag-box {
            width: 100%;
            display: flex;
            // align-items:flex-start;
            align-items: center;
            // justify-content:flex-start;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-bottom: 15px;

            .history-tab {
              display: flex;
              align-items: center;
              gap: 20px;

              .tag-item {
                color: #4d4d4d;
                font-size: 14px;
                padding: 9px 16px;
                cursor: pointer;

                &.active {
                  // background:#1c1c1c;
                  // color:#ffffff;
                  // border-radius:5px;
                  color: #fb486d;
                  font-weight: bold;
                  border-radius: 24px;
                  background: rgba(251, 72, 109, 0.1);
                }
              }
            }

            .batch-box {
              display: flex;
              align-items: center;
              font-size: 14px;
              justify-content: flex-end;
              column-gap: 20px;

              .batch-btn {
                color: #666666;
                cursor: pointer;
              }
            }

            .tag-item-folder {
              color: #4d4d4d;
              font-size: 14px;
              padding: 8px 16px;
              cursor: pointer;

              &.folder-item-active {
                color: #fb486d;
                font-weight: bold;
                border-radius: 24px;
                background: rgba(251, 72, 109, 0.1);
              }
            }
          }

          .content-body-container {
            flex: 1;
            display: flex;
            flex-direction: column;
            row-gap: 20px;
            min-height: 0;
            padding: 20px 20px 30px 10px;

            .top-category-list {
              width: 100%;
              display: flex;
              flex-direction: column;
              row-gap: 5px;

              .top-cate-item {
                display: flex;
                align-items: center;
                column-gap: 10px;
                font-size: 14px;

                .top-cate-label {
                  color: #666;
                }

                .top-cate-list {
                  display: flex;
                  align-items: center;
                  column-gap: 5px;

                  .cate-list-item {
                    color: #333;
                    padding: 1px 10px;
                    border-radius: 10px;
                    cursor: pointer;

                    &.active {
                      background: #ffecee;
                      color: #fa3d5a;
                      font-weight: 500;
                    }
                  }
                }
              }
            }

            .list-body {
              flex: 1;
              overflow-y: auto;
              min-height: 0;
              background: #f6f7fa;
              border-radius: 5px;
              border: 1px solid #ebedf2;
              padding: 15px;
              display: flex;
              // align-items: flex-start;
              align-content: flex-start;
              flex-wrap: wrap;
              column-gap: 15px;
              row-gap: 9px;
              .empty-list{
                width:100%;
                height:100%;
                display:flex;
                align-items:center;
                justify-content:center;
                flex-direction:column;
                .empty-bg{
                  width:140px;
                  height:140px;
                  object-fit:contain;
                  margin-bottom:20px;
                }
                .empty-text{
                  color:#999;
                  font-size:16px;
                  margin-bottom:8px;
                }
                .empty-tips{
                  width:350px;
                  text-align:center;
                  color:#b3b3b3;
                  font-size:14px;
                  word-break:break-word;
                }
              }
              .list-item {
                flex: 0 0 calc(100% / 5 - 15px);
                height: 160px;
                border: 1px solid #e3e4e6;
                border-radius: 5px;
                display: flex;
                flex-direction: column;
                background: #fff;
                position: relative;
                cursor: pointer;
                overflow: hidden;

                &.active {
                  border: 1px solid #fa3d5a;
                }

                .check-icon {
                  width: 25px;
                  height: 25px;
                  position: absolute;
                  top: 0;
                  right: 0;
                  z-index: 10;
                  display: block;
                  box-sizing: border-box;
                }

                .cover-img-box {
                  width: 100%;
                  height: 126px;
                  border-radius: 5px 5px 0 0;
                  overflow: hidden;
                  position: relative;

                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    border-radius: 5px 5px 0 0;
                  }
                  .last-used-tag{
                    position:absolute;
                    top:0;
                    left:0;
                    color:#fff;
                    background:#fa3d5a;
                    padding:2px 5px;
                    z-index:10;
                  }
                  &:hover .last-used-tag{
                    display:none;
                  }
                  &:hover .img-hover {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: 100%;
                    border-radius: 5px 5px 0 0;
                    background: rgba(0, 0, 0, 0.5);
                    display: flex;
                    align-items: flex-end;
                    padding: 0 10px;
                    .model-3d{
                      width:26px;
                      height:26px;
                      cursor:pointer;
                      position:absolute;
                      top:6px;
                      right:8px;
                    }
                    .label-tag {
                      position: absolute;
                      top: 0;
                      left: 0;
                      color: #fff;
                      background: #fa3d5a;
                      padding: 2px 5px;
                      z-index: 10;
                      display:flex;
                      align-items:center;
                      justify-content:center;
                      column-gap:4px;
                    }

                    .hover-btn-box {
                      width: 100%;
                      padding-bottom: 5px;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;

                      .hover-btn-item {
                        color: #fff;
                        font-size: 14px;
                        font-weight: bold;
                        cursor: pointer;
                      }
                    }
                  }
                }

                .name-box {
                  width: 100%;
                  flex: 1;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  overflow: hidden;
                  color: #616366;
                  font-size: 12px;
                  border-top: 1px solid #e3e4e6;

                  span {
                    display: block;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                }
              }

              /* 历史版型相关样式开始 */
              table {
                width: 100%;
                border-collapse: separate;
                border-spacing: 0 9px;
                table-layout: fixed;
                border: none;

                thead {
                  text-align: center;

                  tr {
                    background: #fcfcfd;
                    border-radius: 5px;
                    height: 36px;

                    th {
                      color: #808080;
                      font-size: 14px;
                      line-height: 36px;
                    }
                  }
                }

                tbody {
                  tr {
                    height: 60px !important;
                    max-height: 60px;
                    border-radius: 5px;
                    overflow: hidden;
                    background-color: white;
                    cursor: pointer;

                    &.tr-active {
                      outline: 1px solid #ff5967;
                      position: relative;
                    }

                    td {
                      height: 60px !important;
                      max-height: 60px;
                      vertical-align: middle;
                      position: relative;

                      .selected-icon {
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 25px;
                        height: 25px;
                      }

                      .info-container {
                        padding: 8px;
                        display: flex;
                        align-items: center;
                        column-gap: 14px;

                        .cover-img {
                          width: 94px;
                          height: 94px;
                          border-radius: 3px;
                          border: 1px solid #e3e4e6;
                          flex-shrink: 0;
                        }

                        .item-info {
                          display: flex;
                          flex-direction: column;
                          row-gap: 10px;
                          // width:100%;
                          flex: 1;

                          .title {
                            display: flex;
                            align-items: center;

                            .main {
                              color: #1a1a1a;
                              font-size: 14px;
                              font-weight: bold;
                              width: fit-content;
                              text-overflow: ellipsis;
                              overflow: hidden;
                              white-space: nowrap;
                            }

                            .sub {
                              font-size: 12px;
                              margin-left: 5px;
                              flex-shrink: 0;

                              &.custom-pattern {
                                color: #3f7aca;
                              }

                              &.own-pattern {
                                color: #0caea8;
                              }
                            }
                          }

                          .info {
                            color: #666666;
                            font-size: 12px;
                            line-height: 20px;
                            width: 100%;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                          }
                        }
                      }

                      .style-col {
                        width: 100%;
                        text-align: center;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      }

                      .pattern-no {
                        width: 100%;
                        text-align: center;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      }

                      .sex-info {
                        width: 100%;
                        text-align: center;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      }

                      .operation-col {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        column-gap: 40px;

                        .left-operation {
                          display: flex;
                          align-items: center;
                          column-gap: 10px;
                          font-size: 12px;

                          .btn {
                            cursor: pointer;
                            color: #666666;
                            flex-shrink: 0;
                            white-space: no-wrap;
                            text-overflow: ellipsis;
                            overflow: hidden;

                            &.btn-active,
                            &:hover {
                              color: #fa3d5a;
                            }
                          }

                          .line {
                            color: #cccccc;
                          }
                        }

                        .add-to-team {
                          color: #666666;
                          font-size: 12px;
                          cursor: pointer;
                          flex-shrink: 0;
                          white-space: no-wrap;
                          text-overflow: ellipsis;
                          overflow: hidden;

                          &:hover {
                            color: #fa3d5a;
                          }
                        }
                      }
                    }
                  }
                }

                /* 设置单元格的样式以配合圆角效果 */
                td,
                th {
                  border: none;
                  // border: 1px solid #e8eaec;
                  padding: 8px;

                  &:first-child {
                    border-radius: 5px 0 0 5px;
                    /* 第一列单元格左上、左下圆角 */
                  }

                  &:last-child {
                    border-radius: 0 5px 5px 0;
                    /* 最后一列单元格右上、右下圆角 */
                  }

                  &:first-child:last-child {
                    border-radius: 5px;
                    /* 只有一个单元格时应用全部圆角 */
                  }
                }
              }

              .history-list-item {
                // flex:0 0 49%;
                background: #ffffff;
                border: 1px solid #e3e4e6;
                border-radius: 5px;
                cursor: pointer;

                &.active {
                  border: 1px solid #fa3d5a;
                  position: relative;

                  &::after {
                    position: absolute;
                    top: 0;
                    right: -1px;
                    content: "✔";
                    text-align: center;
                    line-height: 25px;
                    width: 25px;
                    height: 25px;
                    color: #ffffff;
                    background: #fa3d5a;
                    border-top-right-radius: 5px;
                    border-bottom-left-radius: 5px;
                  }
                }

                .item-container {
                  padding: 8px;
                  display: flex;
                  align-items: center;
                  column-gap: 14px;

                  .cover-img {
                    width: 94px;
                    height: 94px;
                    border-radius: 3px;
                    border: 1px solid #e3e4e6;
                  }

                  .item-info {
                    display: flex;
                    flex-direction: column;
                    row-gap: 10px;
                    width: 100%;

                    .title {
                      display: flex;
                      align-items: center;

                      .main {
                        color: #1a1a1a;
                        font-size: 14px;
                        font-weight: bold;
                      }

                      .sub {
                        font-size: 12px;
                        margin-left: 5px;

                        &.custom-pattern {
                          color: #3f7aca;
                        }

                        &.own-pattern {
                          color: #0caea8;
                        }
                      }
                    }

                    .info {
                      color: #666666;
                      font-size: 12px;
                      line-height: 20px;
                      width: 100%;

                      .style-no {
                        width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;

                        &.team {
                          display: flex;
                          align-items: center;
                          column-gap: 10px;

                          div {
                            flex: 1;
                          }
                        }
                      }

                      .btn-line {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;

                        .style-no {
                          flex: 1;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        }

                        .btns {
                          display: flex;
                          align-items: center;
                          font-size: 12px;
                          column-gap: 15px;

                          .btn {
                            color: #666666;
                            cursor: pointer;
                          }

                          .line {
                            width: 1px;
                            height: 12px;
                            background: #cccccc;
                          }
                        }
                      }
                    }
                  }
                }
              }

              /* 历史版型相关样式结束 */
            }
          }
        }

        .self-pattern-form{
            flex:1;
            width:100%;
            padding:24px 32px;
            display:flex;
            flex-direction:column;
            .label-title{
                color:#333;
                font-size:16px;
                font-weight:500;
                span{
                  font-weight:normal !important;
                  font-size:14px;
                }
            }
            .upload-btn{
                width:420px;
                height:48px;
                border:1px solid #e3e3e3;
                border-radius:4px;
                display:flex;
                align-items:center;
                justify-content:center;
                column-gap:8px;
                color:#333;
                font-size:14px;
                cursor:pointer;
                background:transparent;
                margin-top:16px;
                .upload-ico{
                    width:18px;
                    height:18px;
                }
            }
            .self-pattern-box{
                width:100%;
                background:#f8f9fb;
                padding:15px 10px 20px 10px;
                border-radius:4px;
                margin-top:24px;
                margin-bottom:32px;
                .self-pattern-file-box{
                    display:flex;
                    column-gap:16px;
                    row-gap:10px;
                    flex-wrap:wrap;
                    width:100%;
                    background:#f8f9fb;
                    .file-item{
                        flex:0 0 calc(50% - 16px);
                        padding:8px;
                        background:#fff;
                        border-radius:4px;
                        display:flex;
                        align-items:center;
                        column-gap:8px;
                        position:relative;
                        .close-btn{
                            position:absolute;
                            top:8px;
                            right:8px;
                            font-size:14px;
                            color:#999;
                            cursor:pointer;
                        }
                        .file-ico{
                            width:40px;
                            height:40px;
                        }
                        .file-name{
                            flex:1;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            font-size:14px;
                            color:#0d99ff;
                        }
                    }
                    .form-item{
                        display:flex;
                        align-items:center;
                        column-gap:8px;
                        width:100%;
                        .form-item-label{
                            color:#333;
                            font-size:14px;
                        }
                        .form-item-radio-group{
                            display:flex;
                            align-items:center;
                            column-gap:32px;
                            .radio-item{
                                display:flex;
                                align-items:center;
                                column-gap:4px;
                                cursor: pointer;
                                padding: 4px 8px;
                                border-radius: 4px;
                                transition: background 0.2s;
                                user-select:none;
                                
                                input[type="radio"]{
                                    appearance: none;
                                    -webkit-appearance: none;
                                    width: 16px;
                                    height: 16px;
                                    border: 2px solid #ccc;
                                    border-radius: 50%;
                                    outline: none;
                                    cursor: pointer;
                                    position: relative;
                                    flex-shrink: 0;

                                    &:checked {
                                        border-color: #ff4d4f;
                                        background: #ff4d4f;

                                        &::after {
                                        content: "";
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        width: 5px;
                                        height: 10px;
                                        border: solid white;
                                        border-width: 0 2.5px 2.5px 0;
                                        transform: translate(-50%, -60%) rotate(45deg);
                                        }
                                    }
                                }

                                &.radio-disabled {
                                    cursor: not-allowed;
                                    opacity: 0.5;
                                    pointer-events: none;
                                }
                            }
                        }
                        .form-item-input{
                            width:200px;
                            height:46px;
                            display:flex;
                            align-items:center;
                            padding:9px 10px;
                            background:#fff;
                            border:1px solid #e3e3e3;
                            border-radius:4px;
                            input{
                                background:transparent;
                                border:none;
                                outline:none;
                                font-size:14px;
                                color:#333;
                                line-height:28px;
                            }
                        }
                    }
                }
                
            }
            .self-spec-file-box{
                width:100%;
                background:#f8f9fb;
                padding:25px 10px;
                display:flex;
                flex-direction:column;
                row-gap:12px;
                .spec-btn{
                    width:360px !important;
                    height:48px !important;
                    margin-top:0 !important;
                }
                .custom-pattern-file-box {
                    width: 100%;
                    background: #fff;
                    display: flex;
                    flex-direction: column;
                    margin-top: 10px;
                    .custom-pattern-file-item {
                        width: 100%;
                        position: relative;
                        display: flex;
                        align-items: center;
                        column-gap: 10px;
                        .doc-wrap {
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            column-gap: 10px;
                            width: 100%;
                            height: 52px;
                            padding: 0 10px;
                            .icon-doc {
                                width: 24px;
                                height: 24px;
                            }
                            span{
                                flex:1;
                                white-space:nowrap;
                                text-overflow:ellipsis;
                                overflow:hidden;
                            }
                            &.link-disabled {
                                cursor: not-allowed;
                                opacity: 0.6;
                            }
                        }
                        .del-file-icon {
                            position: absolute;
                            top: 6px;
                            right: 16px;
                            cursor: pointer;
                            &.icon-disabled {
                                cursor: not-allowed;
                                opacity: 0.6;
                            }
                        }
                    }
                }
            }
        }
        .custom-pattern-form {
            flex: 1;
            width: 100%;
            padding: 24px 32px;
            display: flex;
            flex-direction: column;
            .pattern-title{
              color:#333;
              font-size:16px;
              font-weight:500;
              width:100%;
              text-align:center;
              margin-bottom:16px;
            }
            .custom-pattern-service {
                display: flex;
                flex-direction: column;
                row-gap: 20px;
                // margin-top: 30px;
                padding:15px 20px;
                background:#f8f9fb;
                .service-item {
                    display: flex;
                    flex-direction: column;
                    row-gap: 10px;
                    .service-item-label {
                        color: #4d4d4d;
                        font-size: 13px;
                    }
                    .form-item-radio-group{
                        display:flex;
                        align-items:center;
                        column-gap:32px;
                        .radio-item{
                            display:flex;
                            align-items:center;
                            column-gap:4px;
                            cursor: pointer;
                            padding: 4px 8px;
                            border-radius: 4px;
                            transition: background 0.2s;
                            user-select:none;
                            
                            input[type="radio"]{
                                appearance: none;
                                -webkit-appearance: none;
                                width: 16px;
                                height: 16px;
                                border: 2px solid #ccc;
                                border-radius: 50%;
                                outline: none;
                                cursor: pointer;
                                position: relative;
                                flex-shrink: 0;

                                &:checked {
                                    border-color: #ff4d4f;
                                    background: #ff4d4f;

                                    &::after {
                                    content: "";
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    width: 5px;
                                    height: 10px;
                                    border: solid white;
                                    border-width: 0 2.5px 2.5px 0;
                                    transform: translate(-50%, -60%) rotate(45deg);
                                    }
                                }
                                &.radio-disabled {
                                    cursor: not-allowed;
                                    opacity: 0.5;
                                    pointer-events: none;
                                }
                            }
                        }
                    }
                    textarea {
                        width: 100%;
                        height: 150px;
                        background: #fff;
                        padding: 10px;
                        border: 1px solid #e3e3e3;
                        border-radius:4px;
                        outline: none;
                        resize: none;
                    }
                }
                .custom-service-file-box {
                    width: 100%;
                    background: #fff;
                    display: flex;
                    flex-direction: column;
                    margin-top: 10px;
                    .custom-service-file-item {
                        width: 100%;
                        position: relative;
                        display: flex;
                        align-items: center;
                        column-gap: 10px;
                        .doc-wrap {
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            column-gap: 10px;
                            width: 100%;
                            height: 52px;
                            padding: 0 10px;
                            background: #f3f3f3;
                            .icon-doc {
                                width: 24px;
                                height: 24px;
                            }
                            span{
                                flex:1;
                                text-overflow:ellipsis;
                                white-space:nowrap;
                                overflow:hidden;
                            }
                            &.link-disabled {
                                cursor: not-allowed;
                                opacity: 0.6;
                            }
                        }
                        .del-file-icon {
                            position: absolute;
                            top: 6px;
                            right: 16px;
                            cursor: pointer;
                            &.icon-disabled {
                                cursor: not-allowed;
                                opacity: 0.6;
                            }
                        }
                    }
                    .btn-upload {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 400px;
                        height: 45px;
                        background: #ffffff;
                        border: 1px solid #b3b3b3;
                        border-radius: 5px;
                        color: #1d1d1d;
                        font-size: 14px;
                        text-align: center;
                        margin: 10px 0;
                        .icon {
                            width: 20px;
                            height: 20px;
                            margin-right: 8px;
                        }
                        &.btn-disabled {
                            cursor: not-allowed;
                            opacity: 0.6;
                        }
                    }
                }
            }
        }
      }
    }

    .my-pattern-library-box {
      flex: 1;
      min-height: 0;
      max-width: 1200px;
      padding: 10px 65px 20px 10px;
      // margin-top: 16px;
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .library-wrapper {
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
      }

      .library-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 0;
        border-bottom: 2px solid #f6f7fa;
        flex-shrink: 0;
        gap: 16px;
        padding:18px 10px 10px 24px;

        .library-title {
          font-size: 20px;
          font-weight: bold;
          color: #1a1a1a;
          flex-shrink: 0;
        }

        .pattern-search-filter-box {
          display: flex;
          align-items: center;
          gap: 16px;
          flex: 1;

          .search-input-wrap {
            width: 280px;
            height: 35px;
            position: relative;

            input {
              width: 100%;
              height: 100%;
              background: #f2f2f2;
              border-radius: 17px;
              padding: 0 45px 0 20px;
              border: none !important;
              font-size: 14px;
              color: #333;
              outline: none;

              &:focus {
                border: none !important;
              }

              &::placeholder {
                color: #999;
              }
            }

            .icon-search {
              position: absolute;
              right: 18px;
              top: 50%;
              transform: translateY(-50%);
              width: 16px;
              height: 16px;
              cursor: pointer;
            }
          }

          .filter-select-wrap {
            position: relative;

            select {
              height: 35px;
              min-width: 120px;
              padding: 0 30px 0 14px;
              border: 1px solid #dcdee2;
              border-radius: 4px;
              font-size: 14px;
              color: #333;
              background: #fff;
              outline: none;
              cursor: pointer;
              appearance: none;
              -webkit-appearance: none;
              -moz-appearance: none;
              transition: all 0.2s;

              &:hover {
                border-color: #57a3f3;
              }

              &:focus {
                border-color: #57a3f3;
                box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.2);
              }
            }

            &::after {
              content: "";
              position: absolute;
              right: 10px;
              top: 50%;
              transform: translateY(-50%);
              width: 0;
              height: 0;
              border-left: 5px solid transparent;
              border-right: 5px solid transparent;
              border-top: 6px solid #808695;
              pointer-events: none;
            }
          }
        }

        .library-close {
          font-size: 24px;
          color: #999;
          cursor: pointer;
          flex-shrink: 0;
          &:hover {
            color: #333;
          }
        }
      }

      .library-body {
        display: flex;
        column-gap: 24px;
        flex: 1;
        min-height: 0;
        padding: 0;
        overflow: hidden;

        .my-pattern-menu {
          flex: 0 0 198px;
          max-width: 198px;
          height: 100%;
          display: flex;
          flex-direction: column;
          row-gap: 10px;
          padding: 0 20px;
          margin-top: 9px;
          overflow-y: auto;

          .menu-parent-item {
            width: 100%;
            height: 35px;
            display: flex;
            align-items: center;
            column-gap: 10px;
            color: #1c1c1c;
            font-size: 14px;
            padding-left: 10px;
            padding-right: 4px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;

            &.active {
              background: #1c1c1c;
              border-radius: 5px;
              color: #ffffff;
            }

            .menu-icon {
              width: 20px;
              height: 20px;
            }

            .label-name {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
          }

          ul {
            margin-left: 39px;

            li {
              list-style-type: square;
              position: relative;
              cursor: pointer;
              color: #4d4d4d;
              font-size: 14px;
              line-height: 40px;

              span {
                display: block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 100%;
              }

              &::marker {
                font-size: 18px;
              }

              &:hover,
              &.active-team {
                color: #ff5967;
              }
            }
          }
        }

        .library-content {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          overflow: hidden;

          .history-tag-box {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-bottom: 15px;

            .history-tab {
              display: flex;
              align-items: center;
              gap: 20px;

              .tag-item {
                color: #4d4d4d;
                font-size: 14px;
                padding: 9px 16px;
                cursor: pointer;

                &.active {
                  color: #fb486d;
                  font-weight: bold;
                  border-radius: 24px;
                  background: rgba(251, 72, 109, 0.1);
                }
              }
            }

            .batch-box {
              display: flex;
              align-items: center;
              font-size: 14px;
              justify-content: flex-end;
              column-gap: 20px;

              .batch-btn {
                color: #666666;
                cursor: pointer;
              }
            }

            .tag-item-folder {
              color: #4d4d4d;
              font-size: 14px;
              padding: 8px 16px;
              cursor: pointer;

              &.folder-item-active {
                color: #fb486d;
                font-weight: bold;
                border-radius: 24px;
                background: rgba(251, 72, 109, 0.1);
              }
            }
          }

          .list-body {
            flex: 1;
            overflow-y: auto;
            min-height: 0;
            background: #f6f7fa;
            border-radius: 5px;
            border: 1px solid #ebedf2;
            padding: 15px;

            table {
              width: 100%;
              border-collapse: separate;
              border-spacing: 0 9px;
              table-layout: fixed;
              border: none;

              thead {
                text-align: center;

                tr {
                  background: #fcfcfd;
                  border-radius: 5px;
                  height: 36px;

                  th {
                    color: #808080;
                    font-size: 14px;
                    line-height: 36px;
                  }
                }
              }

              tbody {
                tr {
                  height: 60px !important;
                  max-height: 60px;
                  border-radius: 5px;
                  overflow: hidden;
                  background-color: white;
                  cursor: pointer;

                  &.tr-active {
                    outline: 1px solid #ff5967;
                    position: relative;
                  }

                  td {
                    height: 60px !important;
                    max-height: 60px;
                    vertical-align: middle;
                    position: relative;

                    .selected-icon {
                      position: absolute;
                      top: 0;
                      right: 0;
                      width: 25px;
                      height: 25px;
                    }

                    .info-container {
                      padding: 8px;
                      display: flex;
                      align-items: center;
                      column-gap: 14px;

                      .cover-img {
                        width: 94px;
                        height: 94px;
                        border-radius: 3px;
                        border: 1px solid #e3e4e6;
                        flex-shrink: 0;
                      }

                      .item-info {
                        display: flex;
                        flex-direction: column;
                        row-gap: 10px;
                        flex: 1;

                        .title {
                          display: flex;
                          align-items: center;

                          .main {
                            color: #1a1a1a;
                            font-size: 14px;
                            font-weight: bold;
                            width: fit-content;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                          }

                          .sub {
                            font-size: 12px;
                            margin-left: 5px;
                            flex-shrink: 0;

                            &.custom-pattern {
                              color: #3f7aca;
                            }

                            &.own-pattern {
                              color: #0caea8;
                            }
                          }
                        }

                        .info {
                          color: #666666;
                          font-size: 12px;
                          line-height: 20px;
                          width: 100%;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        }
                      }
                    }

                    .style-col {
                      width: 100%;
                      text-align: center;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    }

                    .pattern-no {
                      width: 100%;
                      text-align: center;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    }

                    .sex-info {
                      width: 100%;
                      text-align: center;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    }

                    .operation-col {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      flex-direction: column;
                      column-gap: 40px;

                      .left-operation {
                        display: flex;
                        align-items: center;
                        column-gap: 10px;
                        font-size: 12px;

                        .btn {
                          cursor: pointer;
                          color: #666666;
                          flex-shrink: 0;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          overflow: hidden;

                          &.btn-active,
                          &:hover {
                            color: #fa3d5a;
                          }
                        }

                        .line {
                          color: #cccccc;
                        }
                      }

                      .add-to-team {
                        color: #666666;
                        font-size: 12px;
                        cursor: pointer;
                        flex-shrink: 0;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;

                        &:hover {
                          color: #fa3d5a;
                        }
                      }
                    }
                  }
                }
              }

              td,
              th {
                border: none;
                padding: 8px;

                &:first-child {
                  border-radius: 5px 0 0 5px;
                }

                &:last-child {
                  border-radius: 0 5px 5px 0;
                }

                &:first-child:last-child {
                  border-radius: 5px;
                }
              }
            }
          }
        }
      }
    }

    .lesson-box {
      margin-top: 119px;
      width: 100%;
      padding: 0 178px 0 24px;
    }
  }
}

::v-deep .popup-modal {
  /* 核心容器 */
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);

  /* 弹窗内容区 */
  .popup-content {
    background: #fff;
    border-radius: 10px;
    //   width: min(980px, 92vw); // 最大980px，最小占92%视口宽
    /* 修正后 */
    width: max(980px, 96vw); // 增加视口占比
    min-width: 320px; // 保障最小可操作宽度
    max-width: none !important; // 移除潜在限制

    /* 添加边距保护 */
    margin: 0 2vw; // 左右留白
    box-sizing: content-box; // 防止padding影响
    max-height: max(720px, 85vh); // 最大720px，最小占85%视口高
    min-height: 30vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    // padding:0 !important;
  }
}

.fabric-content-wrap {
  margin-top: 40px;
  overflow-y: scroll;
  height: 600px;

  .title-box {
    display: flex;
    align-items: center;
    column-gap: 13px;

    .title {
      color: #1a1a1a;
      font-size: 16px;
      border-left: none;
      font-weight: bold;
      margin-bottom: 0;
      padding: 10px 0;
      height: auto;
    }

    .line {
      flex: 1;
      height: 1px;
      background: #ebebeb;
    }
  }

  .info-wrap {
    display: flex;
    justify-content: space-around;

    .left-popup {
      width: 420px;
      border: 1px solid #e5e5e5;

      .f-img {
        width: 420px;
        height: 420px;
        object-fit: contain;
      }
    }

    .right {
      width: 500px;
      padding-right: 20px;
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: start;

      .name {
        color: #1a1a1a;
        font-size: 20px;
        padding-bottom: 18px;
        width: 100%;
        border-bottom: 1px solid #ebebeb;
        display:flex;
        align-items:center;
        justify-content:space-between;
        .model-btn{
          background: linear-gradient( 45deg, rgba(91,115,255,0.8) 0%, rgba(255,255,255,0) 100%), linear-gradient( 225deg, rgba(223,154,255,0.8) 0%, rgba(255,255,255,0) 100%), radial-gradient( 87.83% 127.36% at 76.57% 100%, #CDF0FF 3.27%, rgba(255,255,255,0.05) 100%);
          border-radius: 16px 16px 16px 16px;
          padding: 3px 10px 3px 3px;
          font-size: 12px;
          cursor: pointer;
          display:flex;
          align-items:center;
          column-gap:4px;
          .model-btn-icon{
            width:26px;
            height:26px;
          }
        }
      }

      .no {
        color: #808080;
        font-size: 14px;
        margin: 25px 0;
        width: 100%;

        span {
          color: #1a1a1a;
          font-size: 14px;
        }
      }

      .item {
        margin: 5px 0;

        .key {
          display: inline-block;
          color: #808080;
          width: 80px;
        }

        .value {
          color: #1a1a1a;
        }
      }
    }
  }

  .richtext-wrap {
    padding: 0 0 15px 0;

    .size-list {
      display: flex;
      align-items: center;
      column-gap: 5px;
      margin-bottom: 10px;

      span {
        background: rgb(237, 245, 254);
        border: 1px solid rgb(230, 241, 253);
        color: rgb(143, 198, 248);
        border-radius: 5px;
        padding: 3px 5px;
      }
    }

    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;
    }

    th,
    td {
      border: 1px solid #ddd;
      padding: 8px;
    }

    th:first-child,
    td:first-child {
      position: sticky;
      left: 0;
      background: white;
      z-index: 1;
      box-shadow: 1px 0 0 #ccc;
      /* 添加视觉分隔 */
    }
  }
}

.btn-box {
  display: flex;
  justify-content: center;
  column-gap: 20px;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background: #ffffff;
  padding: 10px 0;

  .cancel-btn {
    width: 120px;
    height: 38px;
    border-radius: 19px;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    color: #1a1a1a;
    font-size: 14px;
    cursor: pointer;
  }

  .confirm-btn {
    width: 120px;
    height: 38px;
    border-radius: 19px;
    background: #1a1a1a;
    color: #ffffff;
    font-size: 14px;
    cursor: pointer;
  }
}

.slider {
  width: 420px;
  height: 420px;
  overflow: hidden;

  .swiper-slide {
    width: 420px;
    height: 420px;
  }

  .img {
    width: 420px;
    height: 420px;
    object-fit: contain;
  }
}

.custom-fabric-detail {
  overflow-y: scroll;
  width: 100%;
  // height:100%;
  // min-height:600px;
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  height: 100%;

  .title {
    width: 100%;
    border-bottom: 1px solid #e0e0e0;
    font-weight: bold;
    color: #1a1a1a;
    font-size: 20px;
    padding: 20px 30px;
    position: sticky;
    top: 0;
    z-index: 1;
    background: #ffffff;
    flex-shrink: 0;
  }

  .detail-body {
    width: 100%;
    flex: 1;
    overflow-y: auto;

    .container {
      padding: 20px 30px;

      .main-file {
        width: 100%;
        background: #fafafa;
        border: 1px solid #e5e5e5;

        .file-container {
          padding: 26px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .file-left {
            display: flex;
            align-items: center;
            column-gap: 20px;

            .file-ico {
              width: 41px;
              height: 48px;
            }

            .file-name-box {
              display: flex;
              align-items: center;
              column-gap: 10px;

              .name {
                color: #1a1a1a;
                font-size: 18px;
                font-weight: bold;
              }

              .type {
                background: rgba(63, 122, 202, 0.1);
                border-radius: 13px;
                color: #3f7aca;
                font-size: 14px;
                text-align: center;
                padding: 3px 15px;
              }
            }
          }

          .down-btn {
            width: 32px;
            height: 32px;
            background-image: url("../../../../assets/images/icon-download-btn.png");
            cursor: pointer;
            background-position: center;
            background-size: cover;
          }
        }
      }

      .main-info {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        row-gap: 10px;
        margin-top: 30px;

        .info-item {
          display: flex;
          align-items: center;
          column-gap: 20px;
          font-size: 14px;

          .info-label {
            color: #808080;
          }

          .info-value {
            color: #1a1a1a;
          }
        }
      }

      .part-title {
        width: 100%;
        display: flex;
        align-items: center;
        column-gap: 14px;
        margin-top: 50px;

        .title-name {
          color: #1a1a1a;
          font-size: 16px;
          font-weight: bold;
        }

        .title-line {
          flex: 1;
          background: #ebebeb;
          height: 1px;
        }
      }

      .file-list-box {
        width: 100%;
        padding: 20px;
        display: flex;
        flex-direction: column;
        row-gap: 10px;

        .file-list-item {
          width: 100%;
          background: #fafafa;
          border-radius: 5px;
          border: 1px solid #e0e0e0;

          .list-item-container {
            padding: 8px 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .list-item-left {
              display: flex;
              align-items: center;
              column-gap: 13px;

              .item-file-icon {
                width: 31px;
                height: 36px;
              }

              .item-file-name {
                color: #1d1d1d;
                font-size: 14px;
              }
            }

            .list-item-right {
              color: #666666;
              font-size: 12px;
              cursor: pointer;
              margin-right: 10px;

              &:hover {
                color: #5d8eec;
              }
            }
          }
        }
      }
    }
  }

  .detail-bottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 20px;
    flex-shrink: 0;
    border-top: 1px solid #e0e0e0;
    padding: 10px 0;

    .cancel-btn {
      background: #ffffff;
      border-radius: 19px;
      border: 1px solid #e5e5e5;
      color: #333333;
      font-size: 14px;
      padding: 12px 46px;
      cursor: pointer;
    }

    .confirm-btn {
      background: #000000;
      color: #ffffff;
      border-radius: 19px;
      font-size: 14px;
      padding: 12px 31px;
      cursor: pointer;
    }
  }
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.mt-8 {
  margin-top: 8px;
}

.mt-16 {
  margin-top: 16px;
}
</style>
